var na = Object.defineProperty, aa = Object.defineProperties;
var sa = Object.getOwnPropertyDescriptors;
var ee = Object.getOwnPropertySymbols;
var ze = Object.prototype.hasOwnProperty, Ue = Object.prototype.propertyIsEnumerable;
var $e = (t) => {
  throw TypeError(t);
};
var pe = (t, n, e) => n in t ? na(t, n, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[n] = e, w = (t, n) => {
  for (var e in n || (n = {}))
    ze.call(n, e) && pe(t, e, n[e]);
  if (ee)
    for (var e of ee(n))
      Ue.call(n, e) && pe(t, e, n[e]);
  return t;
}, G = (t, n) => aa(t, sa(n));
var be = (t, n) => {
  var e = {};
  for (var a in t)
    ze.call(t, a) && n.indexOf(a) < 0 && (e[a] = t[a]);
  if (t != null && ee)
    for (var a of ee(t))
      n.indexOf(a) < 0 && Ue.call(t, a) && (e[a] = t[a]);
  return e;
};
var H = (t, n, e) => pe(t, typeof n != "symbol" ? n + "" : n, e), Ye = (t, n, e) => n.has(t) || $e("Cannot " + e);
var h = (t, n, e) => (Ye(t, n, "read from private field"), e ? e.call(t) : n.get(t)), F = (t, n, e) => n.has(t) ? $e("Cannot add the same private member more than once") : n instanceof WeakSet ? n.add(t) : n.set(t, e), _ = (t, n, e, a) => (Ye(t, n, "write to private field"), a ? a.call(t, e) : n.set(t, e), e);
var at = (t, n, e) => new Promise((a, s) => {
  var o = (c) => {
    try {
      r(e.next(c));
    } catch (d) {
      s(d);
    }
  }, i = (c) => {
    try {
      r(e.throw(c));
    } catch (d) {
      s(d);
    }
  }, r = (c) => c.done ? a(c.value) : Promise.resolve(c.value).then(o, i);
  r((e = e.apply(t, n)).next());
});
import { jsx as l, jsxs as T, Fragment as Mt } from "react/jsx-runtime";
import { createContext as Bt, useMemo as ae, useState as Xt, useRef as oa, useEffect as Pt, useCallback as Te, useContext as jt, memo as Ce, PureComponent as re, createRef as ia, forwardRef as ra } from "react";
import { TOAST_TYPE as se, MpdLoader as la, MpdIcon as St, useMpdToast as ca, MpdCard as ua, MpdPopover as da, MpdRadio as He } from "@mapado/makeup";
import { Map as Q, List as M, Set as K } from "immutable";
import { getEntityId as D, getShortId as et, DOMAIN_CONTEXT as X, useDomainContext as Ft, getCustomerFullname as rn, getLocale as Xe, downloadFile as fa } from "@mapado/js-component";
import ln, { AVAILABLE_SEAT_BOOKING_STATUS as C, assertRelationIsDefined as I, assertRelationIsObject as E, assertRelationIsString as tt, assertRelationIsListOfObject as Et, SEAT_TYPE as q, assertRelationIsNullOrObject as Y, PagedCollection as cn, Booking as un, AVAILABLE_SEAT_STATUS_AVAILABLE as xt, AVAILABLE_SEAT_STATUS_DISMISSED as ye, assertRelationIsNullOrString as Yt, createEntity as ha, BOOKING_ENTITY_TYPE as We, CART_TYPE as Ke, assertRelationIsNullOrListOfObject as Ze } from "@mapado/ticketing-js-sdk";
import { createI18nPack as Sa } from "@mapado/i18next-pack";
import { useDispatch as ma, useSelector as dn, useStore as ga, connect as pa } from "react-redux";
import Wt from "classnames";
import { G as oe, Circle as fn, Text as N, StyleSheet as Vt, Line as hn, View as y, Page as Le, Rect as ba, Document as je, Svg as Ea, PDFViewer as La, usePDF as va } from "@react-pdf/renderer";
import { Serializer as Aa, HttpError as _a } from "rest-client-sdk";
import { NO_STOCK_CONTINGENT as ve } from "@mapado/cart";
import { createSelector as $ } from "reselect";
import Ta from "svg.js";
import Ca from "panzoom";
const Ht = class Ht {
  static setMoment(n) {
    Ht.moment = n;
  }
  static getMoment() {
    return Ht.moment;
  }
};
H(Ht, "moment");
let Ae = Ht;
class ya extends Aa {
  encodeItem(n) {
    return JSON.stringify(n);
  }
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  decodeItem(n) {
    return Q(JSON.parse(n));
  }
  decodeList(n) {
    const e = JSON.parse(n);
    return Array.isArray(e) ? M(e) : Q(e);
  }
  denormalizeItem(n, e, a) {
    return n && typeof n == "object" && (n.responseDate = a && a.headers && typeof a.headers.get == "function" ? a.headers.get("date") : null), n;
  }
}
function Ia(t, n) {
  const e = new ln(t, n), a = new ya();
  return e.getRepository("eventDate").serializer = a, e.getRepository("seatConfig").serializer = a, e.getRepository("logicalSeatConfig").serializer = a, e.getRepository("availableSeat").serializer = a, e.getRepository("availableSeatModel").serializer = a, e.getRepository("seatGroup").serializer = a, e.getRepository("seat").serializer = a, e;
}
const ut = class ut {
  static createTicketingSdk(n, e) {
    ut.sdk = Ia(n, e), ut.defaultSerializerSdk = new ln(n, G(w({}, e), {
      unitOfWorkEnabled: !0
    }));
  }
  static getSdk() {
    if (!ut.sdk)
      throw new Error("sdk instance must be initialised");
    return ut.sdk;
  }
  static getDefaultSerializerSdk() {
    if (!ut.defaultSerializerSdk)
      throw new Error("defaultSerializerSdk instance must be initialised");
    return ut.defaultSerializerSdk;
  }
};
H(ut, "sdk"), H(ut, "defaultSerializerSdk");
let R = ut;
function Kt(t) {
  return t["@type"] === "AvailableSeat";
}
function Pa(t) {
  return t["@type"] === "Seat";
}
function Ie(t) {
  return t["@type"] === "AvailableSeatModel";
}
function Na(t) {
  return t["@type"] === "StockContingent";
}
function ka(t) {
  return t["@type"] === "SeatConfig";
}
const Sn = "@@mapado-seating/SET_EVENTDATE_DATA", le = "@@mapado-seating/SET_AVAILABLE_SEAT_LIST", wa = "@@mapado-seating/SET_AVAILABLE_SEAT_MODEL_LIST", Ra = "@@mapado-seating/INIT_CLEANUP_STATE", Ga = "@@mapado-seating/REQUEST_BOOKING_COLLECTION", Oa = "@@mapado-seating/RECEIVE_BOOKING_COLLECTION", yi = "@@mapado-seating/RECEIVE_BOOKING", qe = "@@mapado-seating/SET_BOOKING_STATUS", Ii = "@@mapado-seating/ADD_SEAT_CONFIG_BLOCK", Pi = "@@mapado-seating/REMOVE_SEAT_CONFIG_BLOCK", Ni = "@@mapado-seating/UPDATE_SEAT_CONFIG_BLOCK", ki = "@@mapado-seating/UPDATE_SEAT_POSITION", wi = "@@mapado-seating/UPDATE_SEAT_LIST", mn = "@@mapado-seating/SELECT_SEAT_LIST", Ri = "@@mapado-seating/SELECT_SEAT", Da = "@@mapado-seating/SET_AVAILABLE_SEAT_STATUS", Ma = "@@mapado-seating/SET_AVAILABLE_SEAT_LIST_AVAILABLE", Ba = "@@mapado-seating/MOVE_SEAT_LIST_SUCCESS", Fa = "@@mapado-seating/MOVE_SEAT_LIST_FAILURE", xa = "@@mapado-seating/REQUEST_MOVE_SEAT_LIST", Va = "@@mapado-seating/FOCUS_BOOKING", za = "@@mapado-seating/UNFOCUS_BOOKING", Ua = "@@mapado-seating/RESET_BOOKING", $a = "@@mapado-seating/SET_CONTINGENT_TO_AVAILABLE_SEAT_MODEL_LIST", Ya = "@@mapado-seating/SET_STOCK_CONTINGENT_LIST", Ha = "@@mapado-seating/REQUEST_UPDATE_AVAILABLE_SEAT_MODEL_LIST", Xa = "@@mapado-seating/UPDATE_AVAILABLE_SEAT_MODEL_LIST_SUCCESS", Wa = "@@mapado-seating/UPDATE_AVAILABLE_SEAT_MODEL_LIST_FAILURE", Ka = "@@mapado-seating/SET_SEATCONFIG_DATA", Za = "@@mapado-seating/SET_LOGICALSEATCONFIG_DATA", ja = "@@mapado-seating/ADD_SEAT_GROUP", qa = "@@mapado-seating/ADD_CONTINGENT", Ja = "@@mapado-seating/REMOVE_CONTINGENT", Qa = "@@mapado-seating/UPDATE_AVAILABLE_SEAT_LIST_SEAT_GROUP", ts = "@@mapado-seating/SET_CONTRACT", Gi = "@@mapado-seating/PDF_SELECT_CONTINGENT", Oi = "@@mapado-seating/PDF_UNSELECT_CONTINGENT", Di = "@@mapado-seating/PDF_SELECT_SEAT_GROUP", Mi = "@@mapado-seating/PDF_UNSELECT_SEAT_GROUP", es = "@@mapado-seating/RENDERING_CONTEXT_CHANGE";
class Nt extends Error {
  constructor(n) {
    super(n || "This should not happen."), Object.setPrototypeOf(this, Nt.prototype), Error.captureStackTrace && Error.captureStackTrace(this, Nt), this.name = "ShouldNotHappenError";
  }
}
function Bi(t) {
  return [
    C.IN_RESERVATION,
    C.IN_CART,
    C.IN_EXTERNAL_PROVIDER_RESERVATION
  ].includes(t.bookingStatus);
}
function gn(t) {
  return t ? t.get("@type", null) === "Booking" : !1;
}
function _e(t) {
  return t ? t.get("@type", null) === "Cart" : !1;
}
function ne(t) {
  return t ? t.get("@type", null) === "Order" : !1;
}
function ns(t) {
  const n = [];
  return I(t.cartItemList, "cart.cartItemList"), t.cartItemList.forEach((e) => {
    E(e, "cartItem"), I(
      e.availableSeatList,
      "cartItem.availableSeatList"
    ), e.availableSeatList.forEach((a) => {
      E(a, "availableSeat"), n.push(a);
    });
  }), M(n);
}
function as(t) {
  return Et(t.ticketList, "order.ticketList"), t.ticketList.map((n) => n.availableSeat).filter(
    (n) => n !== null && typeof n != "string"
  );
}
const ss = () => {
  const t = {};
  return (n) => {
    const e = String(n.hashCode());
    if (e in t)
      return t[e];
    const a = ns(n);
    return t[e] = a, a;
  };
}, os = () => {
  const t = {};
  return (n) => {
    const e = n.hashCode();
    if (e in t)
      return t[e];
    const a = as(n);
    return t[e] = a, a;
  };
};
function is(t) {
  if (gn(t)) {
    if (t.cart)
      return E(t.cart, "booking.cart"), t.cart;
    if (t.order)
      return E(t.order, "booking.order"), t.order;
  }
  return t;
}
function rs(t, n) {
  let e = M();
  return t.getMembers().forEach((a) => {
    const s = is(a);
    if (I(s, "cartOrOrder"), !ne(s) && !_e(s))
      throw new Nt("We should get a Cart or an Order here");
    const o = ne(s) ? s.orderItemList : s.cartItemList;
    I(o, "itemList"), o.toArray().forEach((i) => {
      var c;
      E(i, "cartOrOrderItem");
      let r = !1;
      if (_e(s)) {
        const d = i;
        I(
          d.availableSeatList,
          "cartItem.availableSeatList"
        ), r = !!d.availableSeatList.find(
          (u) => (E(u, "availableSeat"), E(u.seat, "availableSeat.seat"), typeof u.seat == "string" ? n.has(u.seat) : n.has(u.seat.get("@id") || ""))
        );
      } else if (ne(s)) {
        const d = i;
        I(d.ticketList, "orderItem.ticketList"), r = !!d.ticketList.find((u) => {
          E(
            u.availableSeat,
            "ticket.availableSeat"
          ), E(
            u.availableSeat.seat,
            "ticket.availableSeat.seat"
          );
          const S = u.availableSeat.seat["@id"];
          return tt(S, "seatId"), n.has(S);
        });
      } else
        console.error("bookingType must be a Cart or an Order");
      if (r) {
        E(
          i == null ? void 0 : i.ticketPrice,
          "cartOrOrderItem.ticketPrice"
        ), I(
          (c = i == null ? void 0 : i.ticketPrice) == null ? void 0 : c.ticketPriceSeatGroupList,
          "cartOrOrderItem.ticketPrice.ticketPriceSeatGroupList"
        );
        const d = i.ticketPrice.ticketPriceSeatGroupList.map(
          (u) => (E(u, "tpSeatGroup"), I(
            u.seatGroup,
            "tpSeatGroup.seatGroup"
          ), u.seatGroup)
        );
        e = e.concat(d);
      }
    });
  }), e.toSet().toList();
}
function ls() {
  const t = {};
  return (n, e) => {
    const a = `${n.hashCode()}_${e}`;
    if (!(a in t)) {
      const s = rs(
        n,
        e
      );
      t[a] = s;
    }
    return t[a];
  };
}
const qt = ss(), ce = os(), pn = ls(), ue = (t) => t ? !t.isLocked : !1, Fi = (t) => qt(t).filter(ue), xi = (t) => ce(t).filter(ue);
function cs(t, n) {
  return [
    n.label,
    n.type !== q.NORMAL && n.type !== q.STANDING && t("seat_type", { name: n.type })
  ].filter(Boolean).join(" - ");
}
function Vi(t, n, e, a) {
  const s = n && n.size > 0;
  return !s && !a ? !1 : e && e !== ve ? s && a && D(t.stockContingent) === e : e === ve ? s && a && !t.stockContingent : s && a;
}
const de = ma, B = dn, bn = ga, fe = (t) => t.seating.get("eventDate"), zi = () => B(fe), us = (t) => t.seating.get("pdfInfo"), ds = $(
  fe,
  us,
  (t, n) => {
    var o, i, r, c, d, u;
    const e = n.stockContingent;
    let a = null;
    return e && (E(
      e.contingent,
      "pdfSelectedContingent.contingent"
    ), a = e.contingent.name), {
      eventDateId: t == null ? void 0 : t["@id"],
      eventDateStartDate: t == null ? void 0 : t.startDate,
      ticketingTitle: (o = t == null ? void 0 : t.ticketing) == null ? void 0 : o.title,
      ticketingTimezone: (i = t == null ? void 0 : t.ticketing) == null ? void 0 : i.timezone,
      contingentName: a,
      seatGroupId: (c = (r = n.seatGroup) == null ? void 0 : r["@id"]) != null ? c : null,
      seatGroupName: (u = (d = n.seatGroup) == null ? void 0 : d.label) != null ? u : null
    };
  }
), fs = () => B(ds), kt = (t) => t.seating.get("seatList"), hs = (t) => t.seating.get("stockContingentList"), Ss = () => B(hs), ms = (t) => t.seating.get("contingentList"), mt = (t) => t.seating.get("selectedSeatIdSet"), En = () => B(mt), At = (t) => t.seating.get("availableSeatList"), gs = () => B(At), zt = (t) => t.seating.get("availableSeatModelList"), Ut = (t) => t.seating.get("seatGroupList"), ps = () => B(Ut), Pe = (t) => t.seating.get("seatConfig"), bs = (t) => t.seating.get("logicalSeatConfig");
function Ne(t, n) {
  const e = (At(t) || M()).find((a) => {
    E(a.seat, "as.seat");
    const s = a.seat["@id"];
    return tt(s, "avsSeatId"), s === n;
  });
  if (!e)
    throw new Nt(
      `Unable to fetch available seat for seat id ${n}`
    );
  return e;
}
const Es = $(
  mt,
  At,
  (t, n) => n ? n.filter((e) => {
    E(e.seat, "as.seat");
    const a = e.seat ? Number(e.seat["@id"].replace("/v1/seats/", "")) : null;
    return !!(a && (t != null && t.has(a)));
  }) : null
), Ui = () => {
  const t = bn();
  return Es(t.getState()) || M();
}, _t = $(
  At,
  (t) => {
    const n = {};
    return t ? (t.forEach((e) => {
      if (e.seat) {
        E(e.seat, "as.seat");
        const a = e.seat["@id"];
        n[a] = e;
      }
    }), Q(n)) : Q(n);
  }
), Ls = $(
  zt,
  (t) => {
    const n = {};
    return t ? (t.forEach((e) => {
      e.seat && (E(e.seat, "as.seat"), n[e.seat["@id"]] = e);
    }), Q(n)) : Q(n);
  }
), vs = (t) => t.seating.get("focusedBooking"), Ln = () => B(vs), As = $(
  Pe,
  At,
  Ut,
  kt,
  (t, n, e, a) => t !== null && n !== null && e !== null && a !== null
), $i = $(
  fe,
  (t) => {
    var n, e;
    return t !== null && !!((e = (n = t.ticketing) == null ? void 0 : n.wallet) != null && e.contract);
  }
), _s = $(
  Pe,
  Ut,
  kt,
  (t, n, e) => t !== null && n !== null && e !== null
), Ts = $(
  bs,
  Ut,
  kt,
  zt,
  (t, n, e, a) => t !== null && n !== null && e !== null && a !== null
), vn = $(
  Ut,
  (t) => t ? t.reduce((n, e) => (E(e, "seatGroup"), n.set(e["@id"], e)), Q()) : Q()
), An = $(
  vn,
  (t) => t.map((n) => n.seatColor)
), Yi = $(
  vn,
  (t) => t.map((n) => n.label)
);
function Lt(t) {
  return typeof t == "string" ? t : t["@id"];
}
const Cs = $(
  zt,
  Ut,
  (t) => t ? t.groupBy((n) => (I(n.seatGroup, "avsm.seatGroup"), Lt(n.seatGroup))) : null
), _n = $(
  zt,
  (t) => t ? t.groupBy((n) => n.contingent ? D(n.contingent) : "no-contingent") : null
), ys = $(
  mt,
  (t) => t ? t.join(",") : null
), Hi = $(
  kt,
  mt,
  (t, n) => {
    var a;
    const e = (t || M()).find(
      (s) => (n || K()).has(Number(et(s["@id"])))
    );
    return {
      seatLabel: (a = e == null ? void 0 : e.label) != null ? a : null,
      seatInfoId: e == null ? void 0 : e["@id"]
    };
  }
), Jt = [
  "@id",
  "position",
  "coordinates",
  "label",
  "seatNumber",
  "row",
  "visible",
  "angle",
  "type",
  "seatGroup",
  "zone",
  "floor",
  "hasObstructedView"
], Tn = ["@id", "name", "color"], Cn = [
  "@id",
  "name",
  "color",
  "isExportedOnProvider",
  { contingent: Tn }
], ke = ["@id", "label", "seatColor"], Is = ["@id", "name"], Ps = ["@id", "name"], yn = [
  "eventDate",
  "status",
  "bookingStatus",
  "visible",
  "isLocked",
  "seatGroup",
  "cartItem",
  "ticket"
], In = [
  ...yn,
  { stockContingent: [...Cn] },
  { seatGroup: [...ke] },
  { seat: Jt }
], Ns = [
  ...yn,
  "stockContingent",
  "seatGroup",
  "seat"
], ks = ["status"], Pn = [
  ...ks,
  "contingent",
  "seatGroup",
  "seat"
], we = [
  "@id",
  "label",
  "contract",
  {
    seatConfigBlockList: ["info", "x", "y", "z", "width", "height", "fontSize"]
  },
  { floorList: Ps },
  { zoneList: Is }
], Nn = [
  "name",
  "contract",
  {
    seatConfig: we
  }
], ws = [
  "startDate",
  "endDate",
  "seatConfig",
  "logicalSeatConfig",
  "notInStockContingentBookableStock",
  "nbActiveSeats",
  "issuedTickets",
  "bookedTickets",
  {
    stockContingentList: ["totalStock", "bookableStock"]
  },
  {
    ticketing: ["timezone", "title", { wallet: ["contract"] }]
  },
  {
    ticketPriceList: ["type", "name"]
  }
];
function Rs(t, n) {
  return at(this, null, function* () {
    const e = R.getSdk().getRepository("seatGroup").findBy(
      {
        contract: n,
        availableSeatModelListLogicalSeatConfig: t,
        showHidden: !0,
        itemsPerPage: 9999
      },
      ke
    ), a = R.getSdk().getRepository("contingent").findBy(
      {
        contract: n,
        availableSeatModelListLogicalSeatConfig: t,
        showHidden: !0,
        "order[name]": "ASC",
        itemsPerPage: 9999
      },
      Tn
    ), s = R.getSdk().getRepository("availableSeatModel").findBy(
      {
        contract: n,
        logicalSeatConfig: t,
        itemsPerPage: 9999
      },
      Pn
    ), o = R.getSdk().getRepository("seat").findBy(
      {
        availableSeatModelListLogicalSeatConfig: t,
        itemsPerPage: 9999
      },
      Jt
    ), [i, r, c, d] = yield Promise.all([
      e,
      a,
      o,
      s
    ]), u = d.get("hydra:member").map((S) => {
      const g = i.get("hydra:member").find(
        // @ts-expect-error -- custom serializer typing error
        (m) => m["@id"] === S.seatGroup
      ), p = r.getMembers().find((m) => m.get("@id") === S.contingent) || null, f = c.get("hydra:member").find((m) => m["@id"] === S.seat);
      if (typeof g == "undefined")
        throw new Error(
          `SeatGroup ${S.seatGroup} not found in seatGroupColl for logicalSeatConfig ${t}. This should not happen.`
        );
      if (typeof f == "undefined")
        throw new Error(
          `Seat ${S.seat} not found in seatColl for logicalSeatConfig ${t}. This should not happen.`
        );
      return G(w({}, S), {
        seatGroup: g,
        contingent: p,
        seat: f
      });
    });
    return d.set("hydra:member", u).get("hydra:member");
  });
}
function kn(t) {
  return {
    type: Za,
    logicalSeatConfig: (
      // @ts-expect-error -- custom serializer typing error
      typeof t.toJS == "function" ? t.toJS() : t
    )
  };
}
function he(t, n) {
  return (e) => at(null, null, function* () {
    e({
      type: Ha
    });
    try {
      return yield R.getSdk().getRepository("availableSeatModel").putBulk(
        { "hydra:member": t.toArray() },
        Pn
      ), e({
        type: Xa,
        availableSeatModelList: t,
        updatedFieldName: n
      });
    } catch (a) {
      return e({
        type: Wa,
        error: a
      });
    }
  });
}
function Xi(t) {
  return (n, e) => at(null, null, function* () {
    const a = zt(e());
    if (!a)
      return Promise.resolve();
    const o = ie(
      a,
      mt(e())
    ).map(
      (i) => ({
        "@id": i["@id"],
        "@type": i["@type"],
        status: t
      })
    );
    return n(
      he(o, "status")
    );
  });
}
function Wi(t) {
  return (n, e) => at(null, null, function* () {
    var o;
    const a = _n(e());
    if (!a)
      return Promise.resolve();
    const s = (o = a.get(t)) == null ? void 0 : o.toList().map((i) => ({
      "@id": i["@id"],
      "@type": i["@type"],
      contingent: null
    }));
    return s ? n(
      he(s, "contingent")
    ) : Promise.resolve();
  });
}
function Ki(t) {
  return (n, e) => at(null, null, function* () {
    const a = e().seating.get(
      "availableSeatModelList"
    ), s = _n(e());
    if (!s || !a)
      return Promise.resolve();
    const o = s.get(t) || M(), i = a.filter(
      (u) => !o.find(
        (S) => Lt(S) === Lt(u)
      )
    ), r = ie(
      i,
      mt(e())
    ), c = ie(
      o,
      mt(e())
    ), d = r.map((u) => ({
      "@id": u["@id"],
      "@type": u["@type"],
      contingent: t
    })).concat(
      c.map((u) => ({
        "@id": u["@id"],
        "@type": u["@type"],
        contingent: null
      }))
    );
    return n(
      he(d, "contingent")
    );
  });
}
function Zi(t) {
  return (n, e) => at(null, null, function* () {
    const a = e().seating.get(
      "availableSeatModelList"
    ), s = Cs(e());
    if (!a || !s)
      return Promise.resolve();
    const o = a.filter(
      (c) => {
        var d;
        return !((d = s.get(t)) != null && d.find((u) => Lt(c) === Lt(u)));
      }
    ), r = ie(
      o,
      mt(e())
    ).map(
      (c) => ({
        "@id": c["@id"],
        "@type": c["@type"],
        seatGroup: t
      })
    );
    return n(
      he(r, "seatGroup")
    );
  });
}
function wn(t, n = !1) {
  return (e) => at(null, null, function* () {
    const a = yield R.getSdk().getRepository("logicalSeatConfig").find(t, Nn);
    return n && e(
      Gs(t)
    ), e(kn(a));
  });
}
function Gs(t) {
  return (n, e) => at(null, null, function* () {
    const a = e().seating.get("contract"), s = D(a);
    I(s, "contractId");
    const o = yield Rs(
      t,
      s
    );
    return n({
      type: wa,
      availableSeatModelList: o
    });
  });
}
function ie(t, n) {
  return t.filter((e) => {
    const a = e.seat && D(e.seat);
    return !!(typeof a == "string" && (n != null && n.has(Number(et(a)))));
  }).toList();
}
const Rn = (t, n) => {
  const e = String(n);
  return e.startsWith(t) ? e : `${t}${n}`;
};
function Gn(t) {
  return E(t.seat, "availableSeat.seat"), tt(t.seat["@id"], "availableSeat.seat.@id"), t.seat["@id"];
}
function Os(t) {
  return Number(et(Gn(t)));
}
function ji(t) {
  return E(t.seat, "availableSeat.seat"), tt(
    t.seat["@id"],
    "availableSeat.seat.@id"
  ), Number(et(t.seat["@id"]));
}
function Ds(t, n) {
  let e;
  if ((Kt(t) || Ie(t)) && t.seat) {
    E(t.seat, "seatEntity.seat");
    const a = t.seat["@id"];
    tt(a, "avsSeatId");
    const s = n.get(a);
    if (!s)
      throw new Nt("seat should be found in seatById");
    e = s;
  } else
    e = t;
  if (!e["@id"])
    throw new Nt("seat @id should be defined");
  return e;
}
function Re(t) {
  let n = null, e = null;
  return gn(t) ? (t.cart && (E(t.cart, "booking.cart"), n = t.cart), t.order && (E(t.order, "booking.order"), e = t.order)) : _e(t) ? n = t : ne(t) && (e = t), n !== null ? qt(n) : e !== null ? ce(e) : M();
}
function qi(t, n, e) {
  if (!e)
    return K();
  const a = _t(t), s = Re(e);
  return n.filter((i) => {
    const r = a.get(i);
    return (r ? r.bookingStatus : null) === C.AVAILABLE ? !0 : s.filter((d) => ue(d)).find(
      // @ts-expect-error -- custom serializer typing error
      (d) => d.seat["@id"] === i
    );
  });
}
function Ji(t, n) {
  const e = _t(t);
  return n.filter((a) => {
    const s = e.get(a);
    return s ? s.status === xt : !1;
  });
}
function Qi(t, n, e) {
  var p;
  if (!e)
    return K();
  const a = _t(t), s = (p = t.seating.get("selectedSeatIdSet")) != null ? p : K(), o = qt(e), i = o.map((f) => {
    E(f.seat, "availableSeat.seat");
    const m = f.seat["@id"];
    return tt(m, "availableSeat.seat.@id"), m;
  }).toSet();
  if (s.size === 0)
    return i;
  const r = s.map(
    (f) => `/v1/seats/${f}`
  ), c = new cn({
    "hydra:member": []
  }).setIn(
    ["hydra:member", 0],
    /** @ts-expect-error -- @see https://github.com/mapado/ticketing-js-sdk/issues/250  */
    new un({
      cart: e,
      order: null
    })
  ), d = pn(c, r), u = o == null ? void 0 : o.filter(({ seat: f, stockContingent: m }) => {
    E(f, "seat"), Y(m, "stockContingent");
    const L = m == null ? void 0 : m.get("@id");
    return s.has(+f.getShortId()) && !!L;
  }).map(({ stockContingent: f }) => (Y(f, "stockContingent"), f == null ? void 0 : f.get("@id"))), g = n.filter((f) => {
    const m = a.get(f);
    if (!m)
      throw new TypeError(
        "availableSeat should be defined. This should not happen"
      );
    if (u.size === 0)
      return !m.stockContingent && m.bookingStatus === C.AVAILABLE;
    const L = D(
      m == null ? void 0 : m.stockContingent
    );
    return (
      // availableSeat match stockContingent from selection
      u.includes(
        // @ts-expect-error weird type error due to IRI id type more stricter (https://github.com/mapado/ticketing-js-sdk/pull/482)
        L
      ) && m.bookingStatus === C.AVAILABLE
    );
  }).filter((f) => {
    let m = null;
    if (!t.seating.get("seatConfig"))
      throw new Error(
        "SeatConfig should be set in store. Maybe you forgot to check that `app.loadStatus.seatConfigData` is set"
      );
    const b = a.get(f);
    return b && b.seatGroup && (m = typeof b.seatGroup == "string" ? b.seatGroup : b.seatGroup["@id"]), d.findIndex(
      (P) => D(P) === m
    ) >= 0;
  });
  return n.filter(
    (f) => i.has(f) || g.has(f)
  );
}
function tr(t, n, e, a) {
  const s = _t(t);
  return n.filter((o) => {
    const i = s.get(o);
    return i ? i.status === xt || a.map((c) => c["@id"]).includes(i["@id"]) ? !0 : e.map((c) => c.get("@id")).includes(i["@id"]) : !1;
  });
}
function er(t, n) {
  const e = _t(t);
  return n.filter((a) => {
    const s = e.get(a);
    return s && (s == null ? void 0 : s.status) !== C.AVAILABLE && (s == null ? void 0 : s.status) !== C.DISMISSED && (s == null ? void 0 : s.bookingStatus) !== C.IN_CART;
  });
}
const On = $(
  kt,
  (t) => Q(
    t == null ? void 0 : t.map((n) => [n["@id"], n])
  )
), Dn = () => B(On);
function nr(t, n, e = null) {
  if (!zt(t))
    return K();
  const s = Ls(t);
  return n.filter((o) => {
    const i = s.get(o);
    if (!i)
      return !1;
    if (!i.contingent)
      return !0;
    const r = typeof i.contingent == "string" ? i.contingent : i.contingent["@id"];
    return e !== null && r === D(e);
  });
}
function ar(t, n, e = null) {
  if (fe(t)) {
    const s = _t(t);
    return n.filter((o) => {
      const i = s.get(o);
      if (!i)
        throw new TypeError(
          "availableSeat should be defined. This should not happen"
        );
      return i.stockContingent ? e !== null && D(i.stockContingent) === D(e) : !0;
    });
  }
  const a = On(t);
  return n.filter((s) => {
    const o = a.get(s);
    return o ? o.stockContingent ? e !== null && D(o.stockContingent) === D(e) : !0 : !1;
  });
}
function sr(t, n) {
  const e = _t(t);
  return n.filter((a) => {
    const s = e.get(a);
    return s && s.status === xt;
  });
}
function or(t, n) {
  const e = _t(t);
  return n.filter((a) => {
    const s = e.get(a);
    return s && (s == null ? void 0 : s.status) === xt || (s == null ? void 0 : s.status) === ye;
  });
}
function Ms(t, n) {
  const e = (t.seating.get("seatList") || M()).map((a) => a["@id"]).toSet();
  return n(t, e);
}
function Mn(t, n) {
  return I(t, "cart"), qt(t).find((s) => {
    E(s, "availableSeat"), E(s.seat, "availableSeat.seat"), tt(s.seat["@id"], "availableSeat.seat.@id");
    const o = et(s.seat["@id"]);
    return parseInt(o, 10) === n;
  });
}
function Bn(t, n) {
  return I(t, "order"), ce(t).find((s) => {
    E(s, "availableSeat"), E(s.seat, "availableSeat.seat"), tt(s.seat["@id"], "availableSeat.seat.@id");
    const o = et(s.seat["@id"]);
    return parseInt(o, 10) === n;
  });
}
function Bs(t, n, e) {
  E(t.seatGroup, "seatEntity.seatGroup"), I(n, "cart");
  const a = Mn(n, e);
  return I(a, "availableSeat"), E(a.seatGroup, "availableSeat.seatGroup"), D(a.seatGroup) !== D(t.seatGroup);
}
function Fs(t, n, e) {
  E(t.seatGroup, "seatEntity.seatGroup"), I(n, "cart"), Et(n.cartItemList, "cart.cartItemList");
  const a = n.cartItemList.find((o) => (Et(o.availableSeatList, "ci.availableSeatList"), o.availableSeatList.some((i) => {
    E(i, "ciAvailableSeat"), E(i.seat, "ciAvailableSeat.seat");
    const r = D(i.seat);
    return I(r, "seatId"), parseInt(et(r), 10) === e;
  })));
  return E(a, "cartItem"), E(a.ticketPrice, "cartItem.ticketPrice"), E(
    a.ticketPrice.ticketPriceSeatGroupList,
    "cartItem.ticketPrice.ticketPriceSeatGroupList"
  ), a.ticketPrice.ticketPriceSeatGroupList.some(
    (o) => (E(o, "ticketPriceSeatGroup"), I(
      o.seatGroup,
      "ticketPriceSeatGroup.seatGroup"
    ), E(t.seatGroup, "seatEntity.seatGroup"), o.seatGroup === t.seatGroup["@id"])
  );
}
function xs(t, n, e) {
  E(t.seatGroup, "seatEntity.seatGroup"), I(n, "order"), Et(n.orderItemList, "order.orderItemList");
  const a = n.orderItemList.find((s) => (Et(s.ticketList, "oi.ticketList"), s.ticketList.some((o) => {
    if (E(o, "ticket"), !o.availableSeat)
      return !1;
    E(o.availableSeat, "ticket.availableSeat"), E(
      o.availableSeat.seat,
      "ticket.availableSeat.seat"
    );
    const i = D(o.availableSeat.seat);
    return I(i, "seatId"), parseInt(et(i), 10) === e;
  })));
  return a ? (I(a, "orderItem"), E(a.ticketPrice, "orderItem.ticketPrice"), E(
    a.ticketPrice.ticketPriceSeatGroupList,
    "orderItem.ticketPrice.ticketPriceSeatGroupList"
  ), a.ticketPrice.ticketPriceSeatGroupList.some(
    (o) => (E(o, "ticketPriceSeatGroup"), I(
      o.seatGroup,
      "ticketPriceSeatGroup.seatGroup"
    ), E(t.seatGroup, "seatEntity.seatGroup"), o.seatGroup === t.seatGroup["@id"])
  )) : !1;
}
function ir(t, n, e) {
  if (!e)
    return !1;
  const a = Bs(t, n, e), s = zs(
    t,
    n,
    e
  );
  return a && !Fs(
    t,
    n,
    e
  ) || s;
}
function rr(t, n, e) {
  if (!e)
    return !1;
  const a = Vs(
    t,
    n,
    e
  ), s = Us(
    t,
    n,
    e
  );
  return a && !xs(
    t,
    n,
    e
  ) || s;
}
function Vs(t, n, e) {
  E(t.seatGroup, "seatEntity.seatGroup"), I(n, "order");
  const a = Bn(n, e);
  return I(a, "availableSeat"), E(a.seatGroup, "availableSeat.seatGroup"), D(a.seatGroup) !== D(t.seatGroup);
}
function zs(t, n, e) {
  I(n, "cart");
  const a = Mn(n, e);
  return I(a, "availableSeat"), Y(
    a.stockContingent,
    "availableSeat.stockContingent"
  ), Y(
    t.stockContingent,
    "seatEntity.stockContingent"
  ), D(a.stockContingent) !== D(t.stockContingent);
}
function Us(t, n, e) {
  I(n, "order");
  const a = Bn(n, e);
  return I(a, "availableSeat"), Y(
    a.stockContingent,
    "availableSeat.stockContingent"
  ), Y(
    t.stockContingent,
    "seatEntity.stockContingent"
  ), D(a.stockContingent) !== D(t.stockContingent);
}
function Se(t, n) {
  return at(this, null, function* () {
    const e = R.getSdk().getRepository("seatGroup").findBy(
      {
        availableSeatListEventDate: t,
        showHidden: !0,
        itemsPerPage: 9999
      },
      ke
    ), a = (
      // fetch stockContingent only on desk
      R.getSdk().getRepository("stockContingent").findBy(
        {
          availableSeatListEventDate: t,
          "order[contingent.name]": "ASC",
          itemsPerPage: 9999
        },
        Cn
      )
    ), s = R.getSdk().getRepository("availableSeat").findBy(
      {
        eventDate: t,
        currentCart: n == null ? void 0 : n.currentCartId,
        currentOrder: n == null ? void 0 : n.currentOrderId,
        itemsPerPage: 9999
      },
      Ns
    ), o = R.getSdk().getRepository("seat").findBy(
      {
        availableSeatListEventDate: t,
        itemsPerPage: 9999
      },
      Jt
    ), [i, r, c, d] = yield Promise.all([
      e,
      a,
      o,
      s
    ]), u = (
      // @ts-expect-error -- custom serializer typing error
      Ee(i.get("hydra:member"))
    ), S = Ee(r.getMembers()), g = Ee(c.get("hydra:member"));
    return d.get("hydra:member").map((f) => {
      var P, k;
      const m = f.seatGroup;
      Yt(m, "availableSeat.seatGroup");
      const L = m && (P = u.get(m)) != null ? P : null;
      Yt(
        f.stockContingent,
        "availableSeat.stockContingent"
      );
      const b = f.stockContingent && (k = S.get(f.stockContingent)) != null ? k : null;
      Yt(f.seat, "availableSeat.seat");
      const A = f.seat ? g.get(f.seat) : void 0;
      if (typeof A == "undefined")
        throw new Error(
          `Seat ${f.seat} not found in seatColl for eventDate ${t}. This should not happen.`
        );
      return G(w({}, f), {
        seatGroup: L,
        stockContingent: b,
        seat: A
      });
    });
  });
}
function Ee(t) {
  return Q(t.map((n) => [n["@id"], n]));
}
function it() {
  return {
    type: Ra
  };
}
function $s(t, n) {
  return t.find((a) => (E(a.seat, "avs.seat"), a.seat["@id"] === `/v1/seats/${n}`)) || null;
}
function lr(t) {
  return {
    type: Ma,
    availableSeatList: t
  };
}
function Je(t, n) {
  return {
    type: Da,
    seatId: t,
    bookingStatus: n
  };
}
function Ys(t, n, e, a, s, o, i) {
  return (r) => {
    var S, g;
    r({
      type: xa
    });
    const c = Re(t), d = $s(
      c,
      n
    );
    if (!d)
      throw new Error(
        `Unable to move seat with id ${n} as it is not found in the current state.`
      );
    Yt(d.ticket), Yt(d.cartItem);
    const u = {
      "@id": e,
      "@type": "AvailableSeat",
      ticket: (S = d.ticket) != null ? S : void 0,
      cartItem: (g = d.cartItem) != null ? g : void 0
    };
    return R.getSdk().getRepository("availableSeat").putBulk({ "hydra:member": [u] }, [
      { seatGroup: ["@id", "label"] },
      { seat: Jt },
      "bookingStatus",
      "cartItem",
      "ticket"
    ]).then((p) => p.json()).then((p) => {
      E(
        p["hydra:member"][0],
        "body['hydra:member'][0]"
      );
      const f = p["hydra:member"][0];
      E(f.seat, "body['hydra:member'][0].seat"), tt(
        f.seat["@id"],
        "body['hydra:member'][0].seat['@id']"
      ), r({
        type: Ba,
        availableSeat: f
      }), a(d, ha(f)), o({
        title: i("move_seat.moved.success"),
        type: se.SUCCESS
      });
    }).catch((p) => {
      r({
        type: Fa
      }), console.error(p), s(), o({
        title: i("move_seat.moved.error"),
        type: se.ERROR
      });
    });
  };
}
function vt(t) {
  return (n, e) => {
    const s = e().seating.get("seatList"), o = [], i = K(t);
    return i.size > 0 && (s || M()).forEach((r) => {
      const c = Number(r["@id"].replace("/v1/seats/", ""));
      i.has(c) && o.push(r);
    }), n({
      type: mn,
      seatList: M(o)
    });
  };
}
function Fn() {
  return (t) => {
    t(vt(K()));
  };
}
function cr(t) {
  return (n, e) => {
    var s;
    const a = (s = mt(e())) != null ? s : K();
    n(vt(a.add(t)));
  };
}
function ur(t) {
  return (n, e) => {
    var s;
    const a = (s = mt(e())) != null ? s : K();
    n(vt(a.remove(t)));
  };
}
function Hs(t) {
  return (n) => n({
    type: mn,
    seatList: t
  });
}
function dr(t) {
  return (n, e) => {
    const a = e(), o = (At(a) || M()).map((i) => t.contains(i["@id"]) && i.seat !== null ? Os(i) : null).filter((i) => i !== null).toSet();
    return n(vt(o));
  };
}
function fr(t) {
  return (n, e) => {
    const a = e(), o = (At(a) || M()).map((i) => t.contains(
      i["@id"]
    ) && i.seat !== null ? (E(i.seat, "availableSeat.seat"), Number(
      i.seat["@id"].replace("/v1/seats/", "")
    )) : null).filter((i) => i !== null).toSet();
    return n(vt(o));
  };
}
function hr(t, n, e, a, s, o, i, r, c) {
  return (d, u) => {
    var m;
    const S = u(), g = (m = S.seating.get("selectedSeatIdSet")) != null ? m : K();
    if (!e)
      return Promise.resolve();
    if (a) {
      if ((g == null ? void 0 : g.has(n)) || !1) {
        const A = g.delete(n);
        return d(vt(A));
      }
      const b = g.add(n);
      return d(vt(b));
    }
    let p = null;
    const f = Ne(
      S,
      `/v1/seats/${n}`
    );
    if (!s)
      p = g.first();
    else {
      E(f, "targetAvailableSeat"), E(
        f.seatGroup,
        "targetAvailableSeat.seatGroup"
      );
      const L = new cn({
        "hydra:member": []
      }).setIn(
        ["hydra:member", 0],
        /** @ts-expect-error -- @see https://github.com/mapado/ticketing-js-sdk/issues/250  */
        new un({
          cart: s,
          order: null
        })
      ), b = f.seatGroup;
      p = g.find((A) => {
        const P = pn(
          L,
          K([`/v1/seats/${A}`])
        );
        return !!(b && P.indexOf(
          b["@id"]
        ) >= 0);
      });
    }
    return p ? d(
      Ys(
        t,
        p,
        f["@id"],
        o,
        i,
        r,
        c
      )
    ) : (r({
      title: c("cart_replacement.no_moving_seat_message"),
      type: se.ERROR
    }), Promise.resolve());
  };
}
function Sr(t, n) {
  return (e) => at(null, null, function* () {
    const a = Gn(t), s = Number(et(a)), { bookingStatus: o } = t;
    return o === C.DISMISSED ? R.getSdk().getRepository("availableSeat").putBulk({
      "hydra:member": [
        {
          "@id": t["@id"],
          "@type": "AvailableSeat",
          seat: a,
          status: xt
        }
      ]
    }).then((i) => i.status === 200 ? e(
      Je(
        s,
        C.AVAILABLE
      )
    ) : null).catch((i) => {
      console.error(i), n();
    }) : R.getSdk().getRepository("availableSeat").putBulk({
      "hydra:member": [
        {
          "@id": t["@id"],
          "@type": "AvailableSeat",
          seat: a,
          status: ye
        }
      ]
    }).then((i) => i.status === 200 ? e(
      Je(
        s,
        C.DISMISSED
      )
    ) : null).catch((i) => {
      console.error(i), n();
    });
  });
}
function mr(t) {
  return {
    type: Va,
    booking: t
  };
}
function gr() {
  return {
    type: za
  };
}
function pr(t, n, e) {
  return (a, s) => n ? R.getSdk().getRepository("availableSeat").putBulk({
    "hydra:member": n.map((o) => {
      const i = Ne(
        s(),
        o
      );
      return I(i, "availableSeat"), {
        "@id": i["@id"],
        "@type": "AvailableSeat",
        seat: o,
        status: xt
      };
    }).toArray()
  }).then(() => Se(t)).then((o) => {
    a({
      type: le,
      availableSeatList: o
    }), a(Fn());
  }).catch((o) => {
    console.error(o), e();
  }) : null;
}
function br(t, n, e) {
  return (a, s) => n ? R.getSdk().getRepository("availableSeat").putBulk({
    "hydra:member": n.map((o) => {
      const i = Ne(
        s(),
        o
      );
      return I(i, "availableSeat"), {
        "@id": i["@id"],
        "@type": "AvailableSeat",
        seat: o,
        status: ye
      };
    }).toArray()
  }).then(
    () => Se(t).then(
      (o) => {
        a({
          type: le,
          availableSeatList: o
        }), a(Fn());
      }
    )
  ).catch((o) => {
    console.error(o), e();
  }) : null;
}
function Er(t) {
  return {
    type: $a,
    seatContingentMap: t
  };
}
function Lr(t) {
  return {
    type: ja,
    seatGroup: t
  };
}
function vr(t) {
  return {
    type: qa,
    contingent: t
  };
}
function Ar(t) {
  return {
    type: Ja,
    contingentId: t
  };
}
function _r(t) {
  return {
    type: Qa,
    availableSeatList: t
  };
}
var lt = "#00859c", Xs = "#ff4024", xn = "#30bf97", Tr = "#49658d";
function Vn(t, n = !1) {
  return {
    type: Ka,
    seatConfig: (
      // @ts-expect-error -- custom serializer typing error
      typeof t.toJS == "function" ? t.toJS() : t
    ),
    extractSeatGroupsAndSeats: n
  };
}
function Ws(t, n, e = !1) {
  return (a) => {
    const s = t.replace("/v1/seat_configs/", "");
    n && a(it());
    let o = we;
    return e && (o = [...o, { seatList: Jt }]), R.getSdk().getRepository("seatConfig").find(s, o, {}).then((i) => {
      let r = i;
      const c = {
        "@type": "SeatGroup",
        "@id": "/v1/seat_groups/0",
        seatColor: lt,
        label: "fakeSeatGroup",
        // @ts-expect-error -- custom serializer typing error
        seatList: r.get("seatList")
      };
      return r = r.set("seatGroupList", [c]).set("seatList", null), a(
        Vn(r, e)
      );
    });
  };
}
function Ks(t) {
  const n = [
    {
      seatConfig: we
    },
    {
      logicalSeatConfig: Nn
    }
  ];
  return R.getSdk().getRepository("eventDate").find(t, n).then((e) => {
    const a = e.get("seatConfig"), s = e.get("logicalSeatConfig");
    return s ? (E(
      s,
      "eventDate.logicalSeatConfig"
    ), s) : a ? (E(a, "eventDate.seatConfig"), a) : null;
  });
}
function Qt(t) {
  return (n) => R.getSdk().getRepository("stockContingent").findBy(
    {
      user: "me",
      eventDate: t,
      draft: !1,
      "order[contingent.name]": "ASC",
      itemsPerPage: 9999
    },
    [
      "totalStock",
      "bookableStock",
      "bookedTickets",
      "availableSeatList",
      "draft",
      { contingent: ["@id", "name", "color"] }
    ]
  ).then(
    (e) => e.getMembers()
  ).then((e) => {
    n({
      type: Ya,
      stockContingentList: e
    });
  });
}
function Zs(t, n) {
  return (e) => R.getSdk().getRepository("eventDate").find(t, ws, {}).then((s) => {
    const o = s.toJS();
    return e(Qt(t)), Se(t).then(
      (i) => {
        const r = G(w({}, o), {
          availableSeatList: i
        });
        return e({
          type: le,
          availableSeatList: M(i)
        }), e({
          type: Sn,
          eventDate: r
        }), n && n(), r;
      }
    );
  });
}
function $t(t) {
  return (n) => R.getSdk().getRepository("eventDate").find(
    t,
    [
      "@id",
      "startDate",
      "endDate",
      { ticketing: ["@id", "timezone", "title"] }
    ],
    {}
  ).then((e) => {
    const a = e.toJS();
    n({
      type: Sn,
      eventDate: a
    });
  });
}
function Cr(t) {
  return (n) => {
    const e = t.filter((a) => ue(a)).map((a) => (E(a.seat, "sr.seat"), a.seat));
    return n(Hs(e));
  };
}
function wt(t, n) {
  return (e) => Se(t, n).then(
    (a) => e({
      type: le,
      availableSeatList: a
    })
  );
}
function Rt(t) {
  return (n) => Ks(t).then(
    (e) => {
      if (!e)
        throw new Error(
          `Unable to find seatConfig or logicalSeatConfig for eventDate with id ${t}. You probably tried to load the seating component for an event date without seatConfig.`
        );
      return ka(e) ? n(Vn(e)) : n(
        kn(e)
      );
    }
  );
}
function yr(t, n, e = !0) {
  return (a) => {
    e && a(it());
    const s = [
      // cartId covid19 context
      a(
        wt(n, { currentCartId: t })
      ),
      a(Rt(n)),
      a(Qt(n)),
      a($t(n))
    ];
    return Promise.all(s);
  };
}
function Ir(t) {
  return (n) => (n(it()), n(Ws(t.toString(), !1, !0)));
}
function Pr(t) {
  return (n) => (n(Rt(t)), n($t(t)), n(wt(t)));
}
function Nr(t, n) {
  return (e) => (e(it()), e(Rt(t)), e($t(t)), n === X.DESK && e(Qt(t)), e(wt(t)));
}
function js(t, n) {
  return (e) => {
    const a = [
      e(
        wt(n, {
          currentOrderId: t
        })
      ),
      e(Rt(n)),
      e(Qt(n))
    ];
    return Promise.all(a);
  };
}
function kr(t, n, e = !0) {
  return (a) => (e && a(it()), Promise.all([
    a(js(t, n)),
    a($t(n))
  ]));
}
function wr(t, n) {
  return (e) => {
    e(it());
    const a = [
      e(
        wt(n, { currentCartId: t })
      ),
      e(Rt(n)),
      e($t(n))
    ];
    return Promise.all(a);
  };
}
function Rr({
  eventDateId: t,
  hasError: n
}) {
  return (e) => {
    if (n && e(it()), !t)
      throw new Error("EventDateId should be defined");
    return e(Zs(t)).then((a) => {
      if (a.logicalSeatConfig)
        return tt(
          a.logicalSeatConfig,
          "eventDate.logicalSeatConfig"
        ), e(Qt(t)), e(
          wn(
            a.logicalSeatConfig.replace(
              /\/v\d+\/logical_seat_configs\//,
              ""
            )
          )
        );
      throw new Error(
        "EventDate should have one of logicalSeatConfig or seatConfig"
      );
    });
  };
}
function Gr({
  eventDateId: t,
  hasError: n
}) {
  return (e) => (n && e(it()), qs({ eventDateId: t, hasError: n }));
}
function qs({
  eventDateId: t,
  hasError: n
}) {
  return (e) => {
    if (n && e(it()), !t)
      throw new Error("eventDateId should be defined. This should not happen.");
    Promise.all([
      e(Rt(t)),
      e(wt(t))
    ]);
  };
}
function Or(t = null) {
  return (n) => {
    if (n(it()), !t)
      throw new Error(
        "logicalSeatConfigId should be defined. This should not happen."
      );
    return n(
      wn(t.toString(), !0)
    );
  };
}
function Dr(t) {
  return (n) => {
    n(it());
    const e = [
      n(Rt(t)),
      n(wt(t)),
      n($t(t))
    ];
    return Promise.all(e);
  };
}
function Js(t) {
  return {
    type: ts,
    contract: t
  };
}
const Tt = "tool_select_seat_free_drawing";
function Qs(t) {
  const e = t.replace("translate(", "").replace(")", "").replace(" ", "").split(","), a = parseInt(e[0], 10), s = parseInt(e[1], 10);
  return {
    x: a,
    y: s
  };
}
const Qe = 1.6;
let ct = null;
function Ge() {
  if (!ct)
    throw new Error(
      "Unable to get SvgPanZoomInstance. Did you forgot to call `initSvgPanZoom` ?"
    );
  return ct;
}
function to(t) {
  ct = Ca(t, {
    zoomSpeed: 0.1,
    // 10% per mouse wheel event
    maxZoom: 3,
    minZoom: 0.05,
    autocenter: !0,
    smoothScroll: !1,
    beforeWheel: (o) => Math.abs(o.deltaY) < 100
  });
  const n = document.querySelector(".draggableSVG");
  I(n, "svgContainer");
  const e = n.getBoundingClientRect(), a = e.width / 2, s = e.height / 2;
  return ct.zoomBy = function(o, i, r) {
    this.zoomTo(i, r, o);
  }, ct.zoomIn = function() {
    this.smoothZoom(a, s, 1 * Qe);
  }, ct.zoomOut = function() {
    this.smoothZoom(a, s, 1 / Qe);
  }, ct.disablePan = function() {
    this.pause();
  }, ct.enablePan = function() {
    this.resume();
  }, ct.destroy = function() {
    this.dispose();
  }, ct;
}
function eo() {
  Ge().disablePan();
}
function no() {
  Ge().enablePan();
}
const ao = "free-hand-draw-seat-selector-path";
var dt, Zt, Ot, x, ft, j, Dt, Ct, ht;
class so {
  constructor(n) {
    F(this, dt);
    F(this, Zt);
    F(this, Ot);
    F(this, x);
    F(this, ft);
    F(this, j);
    F(this, Dt);
    F(this, Ct);
    F(this, ht);
    _(this, dt, []), _(this, Zt, n), this.clear = this.clear.bind(this), this.reset = this.reset.bind(this), this.handleMouseMove = this.handleMouseMove.bind(this), this.handleTouchEnd = this.handleTouchEnd.bind(this), this.updateSvgPath = this.updateSvgPath.bind(this), this.appendToBuffer = this.appendToBuffer.bind(this), this.getAveragePoint = this.getAveragePoint.bind(this), this.clear(), _(this, x, null), _(this, ft, ""), _(this, j, []), _(this, Dt, 4), _(this, Ot, "mpd-seating__seat--is-selectable"), _(this, ht, {
      startX: null,
      startY: null
    });
  }
  reset() {
    this.clear(), _(this, dt, []), _(this, x, null), _(this, ft, ""), _(this, j, []);
  }
  onSelectedSeatIdListChange(n) {
    n && n.size === 0 && this.reset();
    const e = (n == null ? void 0 : n.toList().map((a) => document.getElementById(String(a))).filter((a) => a !== null)).toArray();
    _(this, dt, e);
  }
  clear() {
    const n = document.getElementsByClassName(
      "free-hand-draw-seat-selector-path"
    );
    for (; n[0]; )
      n[0].parentNode && n[0].parentNode.removeChild(n[0]);
    _(this, ht, {
      startX: null,
      startY: null
    });
  }
  init(n = {}) {
    typeof n.selectableSeatSelector != "undefined" && _(this, Ot, n.selectableSeatSelector), _(this, Ct, document.getElementsByClassName(
      h(this, Ot)
    ));
  }
  /**
   * Finish the current selection, and sends an event to redux
   */
  finishSelection() {
    this.clear(), import("raphael").then(({ default: n }) => {
      const e = n(0, 0, 0, 0), a = e.path(h(this, ft)), s = [];
      if (h(this, Ct))
        for (let r = 0; r < h(this, Ct).length; r++) {
          const c = h(this, Ct)[r], d = c.getAttribute("transform");
          if (d === null)
            throw new Error("seatNode should have a `transform` attribute");
          const { x: u, y: S } = Qs(d);
          a.isPointInside(u, S) && s.push(c);
        }
      const o = h(this, dt).filter(
        (r) => s.indexOf(r) >= 0
      );
      _(this, dt, h(this, dt).concat(s).filter(
        (r) => o.indexOf(r) === -1
      ));
      const i = h(this, dt).map((r) => {
        const c = r.getAttribute("id");
        return c ? parseInt(c, 10) : null;
      }).filter((r) => !!r);
      h(this, Zt).call(this, i), _(this, x, null), e.remove();
    });
  }
  appendToBuffer(n) {
    for (h(this, j).push(n); h(this, j).length > h(this, Dt); )
      h(this, j).shift();
  }
  getAveragePoint(n) {
    const e = h(this, j).length;
    if (e % 2 === 1 || e >= h(this, Dt)) {
      let a = 0, s = 0, o, i, r = 0;
      for (i = n; i < e; i++)
        r += 1, o = h(this, j)[i], a += o.x, s += o.y;
      return {
        x: a / r,
        y: s / r
      };
    }
    return null;
  }
  updateSvgPath() {
    let n = this.getAveragePoint(0);
    if (n) {
      _(this, ft, h(this, ft) + ` L${n.x} ${n.y}`);
      let e = "";
      for (let a = 2; a < h(this, j).length; a += 2)
        n = this.getAveragePoint(a), n && (e += ` L${n.x} ${n.y}`);
      h(this, x) && h(this, x).setAttribute("d", h(this, ft) + e);
    }
  }
  handleTouchStart(n, e) {
    const { startX: a, startY: s } = h(this, ht);
    if (a === null || s === null) {
      eo(), h(this, ht).startX = n, h(this, ht).startY = e, _(this, x, document.createElementNS(
        "http://www.w3.org/2000/svg",
        "path"
      )), h(this, x).setAttribute("fill", "none"), h(this, x).setAttribute("stroke", "#000"), h(this, x).setAttribute("stroke-width", "2"), h(this, x).classList.add(ao), _(this, j, []), this.appendToBuffer({
        x: n,
        y: e
      }), _(this, ft, `M${n} ${e}`), h(this, x).setAttribute("d", h(this, ft));
      const o = document.getElementById("seatingSVG");
      if (!o)
        throw new Error(
          "Unable to find element with id `seatingSVG`. This should not happen."
        );
      o.childNodes[0].appendChild(h(this, x));
    }
  }
  handleTouchEnd() {
    const { startX: n, startY: e } = h(this, ht);
    n !== null && e !== null && h(this, x) && (_(this, j, []), this.appendToBuffer({ x: n, y: e }), this.updateSvgPath(), window.requestAnimationFrame(() => {
      this.finishSelection();
    }), no());
  }
  handleMouseMove(n, e, a, s) {
    const { startX: o, startY: i } = h(this, ht);
    o !== null && i !== null && h(this, x) && (this.appendToBuffer({ x: a, y: s }), this.updateSvgPath());
  }
}
dt = new WeakMap(), Zt = new WeakMap(), Ot = new WeakMap(), x = new WeakMap(), ft = new WeakMap(), j = new WeakMap(), Dt = new WeakMap(), Ct = new WeakMap(), ht = new WeakMap();
var z, pt, ot, U, gt, yt;
class oo {
  constructor({ selectBatchOfSeats: n }) {
    F(this, z);
    F(this, pt);
    F(this, ot);
    F(this, U);
    F(this, gt);
    F(this, yt);
    _(this, z, null), _(this, pt, null), _(this, ot, null), n && _(this, U, new so(
      n
    )), this.handleMouseMove = this.handleMouseMove.bind(this), this.handleTouchEnd = this.handleTouchEnd.bind(this), this.handleTouchStart = this.handleTouchStart.bind(this), this.clear(), _(this, gt, null), _(this, yt, null);
  }
  setMode(n, e = {}) {
    n !== h(this, ot) && (this.clear(), n === Tt ? this.initModeFreeHandDrawSelector(e) : _(this, ot, null));
  }
  clear() {
    h(this, U) && h(this, U).clear();
  }
  restoreCursor() {
    h(this, z) && h(this, yt) !== null && (h(this, z).node.style.cursor = h(this, yt));
  }
  init() {
    _(this, z, Ta.get("seatingSVG")), import("hammerjs").then(({ default: n }) => {
      if (!h(this, z))
        throw new Error("Unable to find `seatingSVG`. This should not happen.");
      _(this, yt, h(this, z).node.style.cursor), new n(h(this, z).node).get("press").set({
        time: 600,
        pointers: 1
      }), h(this, z).mousemove(this.handleMouseMove), h(this, z).mousedown(this.handleTouchStart), h(this, z).mouseup(this.handleTouchEnd);
      const a = h(this, z).children();
      a && _(this, pt, a[0]), _(this, gt, h(this, z).node.createSVGPoint());
    });
  }
  initModeFreeHandDrawSelector(n) {
    if (!h(this, U))
      throw new Error(
        'Unable to call "initModeFreeHandDrawSelector" if "selectBatchOfSeats" is null.'
      );
    h(this, U).init(n), _(this, ot, Tt);
  }
  handleSelectedSeatIdListChange(n) {
    h(this, ot) === Tt && h(this, U) && h(this, U).onSelectedSeatIdListChange(
      n
    );
  }
  /**
   * The lib does its stuff inside a SVG. Unfortunately,
   * We draw everything inside a <g> element used by svgPanZoom
   * so the scales and positions aren't the same
   * This function converts the mouse position inside the SVG to the mouse position inside the g
   * @see https://stackoverflow.com/questions/10298658/mouse-position-inside-autoscaled-svg
   */
  cursorPoint(n, e) {
    if (!h(this, gt) || !h(this, pt))
      throw new Error(
        'Unable to call "cusorPoint" if #pt  or #baseElement is null.'
      );
    return h(this, gt).x = n, h(this, gt).y = e, h(this, gt).matrixTransform(
      /** @ts-expect-error -- svgjs types can not describe the type of the element node */
      h(this, pt).node.getScreenCTM().inverse()
    );
  }
  handleMouseMove(n) {
    if (h(this, ot) === null)
      return;
    const e = this.cursorPoint(n.clientX, n.clientY);
    h(this, ot) === Tt && h(this, U) && h(this, U).handleMouseMove(
      h(this, z),
      h(this, pt),
      e.x,
      e.y
    );
  }
  handleTouchStart(n) {
    const e = this.cursorPoint(n.clientX, n.clientY);
    h(this, ot) === Tt && h(this, U) && h(this, U).handleTouchStart(e.x, e.y);
  }
  handleTouchEnd() {
    this.restoreCursor(), h(this, ot) === Tt && h(this, U) && h(this, U).handleTouchEnd();
  }
}
z = new WeakMap(), pt = new WeakMap(), ot = new WeakMap(), U = new WeakMap(), gt = new WeakMap(), yt = new WeakMap();
function io() {
  var r;
  const [t, n] = Xt(!1), e = (r = En()) != null ? r : K(), a = de(), s = oa(
    new oo({
      selectBatchOfSeats: (c) => a(vt(c))
    })
  );
  Pt(() => {
    var c, d, u;
    t ? ((c = s.current) == null || c.setMode(Tt), (d = s.current) == null || d.handleSelectedSeatIdListChange(e)) : (u = s.current) == null || u.setMode(null);
  }, [t]);
  const o = B(ys);
  Pt(() => {
    var c;
    (c = s.current) == null || c.handleSelectedSeatIdListChange(e);
  }, [o]);
  const i = Te(
    (c) => {
      var d;
      c && ((d = s.current) == null || d.init());
    },
    [s]
  );
  return { isDrawing: t, setIsDrawing: n, setSvgDrawerRef: i };
}
const zn = Bt(null);
function ro({
  children: t
}) {
  const { isDrawing: n, setIsDrawing: e, setSvgDrawerRef: a } = io(), s = ae(
    () => ({ isDrawing: n, setIsDrawing: e, setSvgDrawerRef: a }),
    [n, e, a]
  );
  return /* @__PURE__ */ l(zn.Provider, { value: s, children: t });
}
function lo() {
  const t = jt(zn);
  if (t === null)
    throw new Error(
      "useDrawingContext must be used within a DrawingContextProvider"
    );
  return t;
}
const co = Bt(null);
co.displayName = "RenderingNameContext";
function uo({
  children: t,
  renderingContext: n
}) {
  const e = de();
  return Pt(() => {
    e({ type: es, renderingContext: n });
  }, [e, n]), t;
}
function Un() {
  return dn(
    (t) => t.seating.get("renderingContext")
  );
}
var O = /* @__PURE__ */ ((t) => (t.Contingent = "contingent", t.SeatGroup = "seatGroup", t))(O || {});
const $n = Bt(null);
function fo({
  children: t,
  viewList: n,
  selectedView: e,
  onSelectView: a
}) {
  const [s, o] = Xt(
    n.includes(
      "contingent"
      /* Contingent */
    ) ? "contingent" : n[0]
  ), i = ae(
    () => ({
      viewList: n,
      selectedView: e != null ? e : s,
      onSelectView: a != null ? a : o
    }),
    [s, a, e, n]
  );
  return /* @__PURE__ */ l($n.Provider, { value: i, children: t });
}
const Oe = () => {
  const t = jt($n);
  if (!t)
    throw new Error("useViewContext must be used within a ViewContextProvider");
  return t;
}, tn = Bt(!1), ho = Ce(
  ({
    name: t,
    children: n,
    viewList: e = [O.Contingent, O.SeatGroup],
    selectedView: a,
    onSelectView: s
  }) => {
    const o = jt(tn), i = de();
    return Pt(() => () => {
      o || i(it());
    }, [i, o]), o ? n : /* @__PURE__ */ l(tn.Provider, { value: !0, children: /* @__PURE__ */ l(uo, { renderingContext: t, children: /* @__PURE__ */ l(
      fo,
      {
        viewList: e,
        selectedView: a,
        onSelectView: s,
        children: /* @__PURE__ */ l(ro, { children: n })
      }
    ) }) });
  }
);
function Mr({
  name: t,
  contract: n,
  children: e,
  viewList: a = [O.Contingent, O.SeatGroup],
  selectedView: s,
  onSelectView: o
}) {
  const i = B(
    (c) => c.seating.get("contract")
  ), r = de();
  return Pt(() => {
    r(Js(n));
  }, [n, r]), i ? /* @__PURE__ */ l(
    ho,
    {
      name: t,
      viewList: a,
      selectedView: s,
      onSelectView: o,
      children: e
    }
  ) : /* @__PURE__ */ l("div", { className: "mpd-seating__app--is-loading", children: /* @__PURE__ */ l(la, {}) });
}
const So = {
  elementList: {},
  hiddenPlanContext: [],
  selectedIndex: null,
  onSelect: (t) => {
  }
}, mo = Bt(So), go = () => jt(mo), po = "seating", bo = ["main"], Eo = "main", Lo = ["fr", "en", "de"], vo = "fr";
function Ao(t, n) {
  if (n === "main")
    switch (t) {
      case "fr":
        return import("./main-Bx2w1_ZD.js");
      case "en":
        return import("./main-f7biIl90.js");
      case "de":
        return import("./main-BU1cYssg.js");
      default:
        return Promise.reject(new Error(`Do not handle locale ${t}`));
    }
  throw new Error('Namespace must be "main"');
}
const { i18n: W, useTranslation: Gt } = Sa(
  po,
  bo,
  Eo,
  Lo,
  vo,
  Ao
);
function Br({
  children: t,
  action: n,
  onClose: e = null,
  className: a = ""
}) {
  const { t: s } = Gt();
  return /* @__PURE__ */ T("div", { className: `mpd-seating-sidebar ${a}`, children: [
    typeof e == "function" && /* @__PURE__ */ T(Mt, { children: [
      /* @__PURE__ */ T(
        "button",
        {
          type: "button",
          onClick: e,
          className: "mpd-seating-sidebar__close-seating-btn",
          children: [
            /* @__PURE__ */ l(St, { icon: "cross", height: "24", width: "24" }),
            s("close")
          ]
        }
      ),
      /* @__PURE__ */ l("div", { className: "mpd-seating-sidebar__close-seating-spacing" })
    ] }),
    /* @__PURE__ */ l(
      "div",
      {
        className: `mpd-seating-sidebar__scrollable ${typeof e == "function" ? "mpd-seating-sidebar__scrollable--with-close" : ""}`,
        children: t
      }
    ),
    n && /* @__PURE__ */ l("div", { className: "plan-purchase-sidebar__actions", children: n })
  ] });
}
function _o(t, n) {
  const e = t === C.IN_CART, a = t === C.IN_ORDER, s = t === C.IN_RESERVATION, o = t === C.DISMISSED, i = t === C.AVAILABLE, r = t === C.SCANNED, c = t === C.IN_EXTERNAL_PROVIDER_ORDER, d = t === C.IN_EXTERNAL_PROVIDER_RESERVATION;
  let u = "seat-filled";
  return o && (u = "disallow"), i && (u = "seat-filled"), c && (u = "external-provider-filled"), d && (u = "external-provider"), !n && s && (u = "participant"), !n && e && (u = "cart"), !n && a && (u = "participant-filled"), !n && r && (u = "check-filled"), u;
}
function To(t, n) {
  let e = t;
  if (e.indexOf("#") === 0 && (e = e.slice(1)), e.length === 3 && (e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]), e.length !== 6)
    throw new Error(`Invalid HEX color. "${e}"`);
  const a = parseInt(e.slice(0, 2), 16), s = parseInt(e.slice(2, 4), 16), o = parseInt(e.slice(4, 6), 16);
  return a * 0.299 + s * 0.587 + o * 0.114 > 186 ? "#000000" : "#FFFFFF";
}
function Fr(t) {
  if (!t)
    throw new Error("Item should be defined. This should not happen.");
  return t;
}
const J = {
  size: 30,
  iconSize: 24,
  iconZoomedSize: 30
}, me = (t) => typeof t == "string" ? parseFloat(t) : t;
function Yn(t) {
  return J.size * me(t) - 10;
}
function Hn(t) {
  return -30 * me(t) - 10;
}
function xr(t) {
  return me(t) / -30;
}
function Vr(t) {
  return me(t) / J.size;
}
const Co = Ce(
  ({
    icon: t,
    width: n,
    fill: e,
    type: a,
    hasObstructedView: s
  }) => {
    const { currentDomain: o } = Ft(), i = o === X.DESK, r = i ? t : "seat-filled", d = (() => {
      switch (a) {
        case q.FOLDABLE:
        case q.CHAIR:
        case q.BENCH:
        case q.BANQUETTE:
          return s ? "seat-foldable-obstructed-view" : "seat-foldable-filled";
        case q.STANDING:
          return s ? "seat-standing-obstructed-view" : i ? "seat-standing" : null;
        case q.REDUCED_MOBILITY:
          return s ? "reduced-mobility-obstructed-view" : "reduced-mobility";
        case q.NORMAL:
          return s ? "seat-obstructed-view" : r;
        default:
          return r;
      }
    })();
    return d ? /* @__PURE__ */ l(
      St,
      {
        icon: r !== "seat-filled" ? t : d,
        width: `${n}`,
        color: e
      }
    ) : null;
  }
);
var It, bt;
class Xn extends re {
  constructor(e) {
    super(e);
    // eslint-disable-next-line react/sort-comp
    F(this, It);
    F(this, bt);
    H(this, "hoverTimeout");
    this.state = {
      isHoverActive: !1
    }, this.onHover = this.onHover.bind(this), this.handleSeatFocus = this.handleSeatFocus.bind(this), this.onHoverOut = this.onHoverOut.bind(this), this.handleClick = this.handleClick.bind(this), _(this, It, ia()), _(this, bt, null), this.hoverTimeout = null;
  }
  componentDidMount() {
    import("hammerjs").then(({ default: e }) => {
      h(this, It).current && (_(this, bt, new e(h(this, It).current)), h(this, bt).on("tap", this.handleClick));
    });
  }
  componentWillUnmount() {
    h(this, bt) && h(this, bt).destroy(), this.hoverTimeout && clearTimeout(this.hoverTimeout);
  }
  handleClick() {
    const { isSelectable: e, isSelected: a, onClickSeat: s, seatEntity: o } = this.props;
    s && s(o, a, e);
  }
  handleSeatFocus(e, a) {
    const { isHoverActive: s } = this.state, { onFocusSeat: o, isDesk: i } = this.props;
    (s || !i) && o(e, a);
  }
  onHover() {
    const { seatId: e, seatEntity: a, isDesk: s } = this.props;
    this.hoverTimeout && clearTimeout(this.hoverTimeout), this.setState({ isHoverActive: !0 }), Kt(a) && s ? this.hoverTimeout = window.setTimeout(() => at(this, null, function* () {
      try {
        const o = yield R.getSdk().getRepository("availableSeat").find(et(a["@id"]), [
          { ticket: [{ participant: ["firstname", "lastname"] }] },
          { cartItem: [{ participant: ["firstname", "lastname"] }] }
        ]), i = o.getIn([
          "ticket",
          "participant"
          // get availableSeat uses rawSerializer, returns Map<any, any>
        ]), r = o.getIn([
          "cartItem",
          "participant"
        ]), c = i || r || null;
        this.handleSeatFocus(e, c);
      } catch (o) {
        this.handleSeatFocus(e, null);
      }
    }), 300) : this.hoverTimeout = window.setTimeout(() => {
      this.handleSeatFocus(e, null);
    }, 0);
  }
  onHoverOut() {
    const { onUnfocusSeat: e, seatId: a } = this.props;
    this.setState({ isHoverActive: !1 }), e(a), this.hoverTimeout && clearTimeout(this.hoverTimeout);
  }
  getPosX() {
    const { coordinates: e } = this.props;
    return Yn(e.X);
  }
  getPosY() {
    const { coordinates: e } = this.props;
    return Hn(e.Y);
  }
  render() {
    const {
      fill: e,
      label: a,
      isSelected: s,
      isZoomed: o,
      isMovingSeat: i,
      seatId: r,
      isSelectable: c,
      icon: d,
      displaySeatLabel: u,
      bookingStatus: S,
      displayDismissedSeat: g,
      angle: p,
      type: f,
      hasObstructedView: m
    } = this.props;
    if (!g && S === C.DISMISSED)
      return null;
    const L = o ? this.getPosX() - 2 : this.getPosX(), b = o ? this.getPosY() - 2 : this.getPosY(), A = o ? J.iconZoomedSize : J.iconSize, P = c ? "mpd-seating__seat--is-selectable" : "", k = s ? "mpd-seating__seat--is-selected" : "", V = i ? "mpd-seating__seat--is-moving-seat" : "";
    return /* @__PURE__ */ T(
      "g",
      {
        ref: h(this, It),
        className: `mpd-seating__seat ${P} ${k} ${V}`,
        transform: `translate(${L}, ${b})  rotate(${p != null ? p : 0} 12 12)`,
        id: String(r),
        onMouseEnter: this.onHover,
        onMouseLeave: this.onHoverOut,
        children: [
          f !== q.STANDING && /* @__PURE__ */ l("rect", { x: "0", y: "0", width: A, height: A, fill: "transparent" }),
          /* @__PURE__ */ l(
            Co,
            {
              icon: d,
              fill: e,
              width: A,
              type: f,
              hasObstructedView: m
            }
          ),
          u && /* @__PURE__ */ l(
            "text",
            {
              x: "11",
              y: "7",
              fill: To(e),
              dy: ".3em",
              textAnchor: "middle",
              fontSize: "0.6em",
              textRendering: "optimizeSpeed",
              children: a
            }
          )
        ]
      }
    );
  }
}
It = new WeakMap(), bt = new WeakMap(), H(Xn, "defaultProps", {
  displaySeatLabel: !1
});
function zr(t) {
  const { currentDomain: n } = Ft(), e = n === X.DESK;
  return /* @__PURE__ */ l(Xn, G(w({}, t), { isDesk: e }));
}
const Z = (t) => typeof t == "number" ? t : parseFloat(t.replace("px", ""));
function yo(t) {
  const n = t.match(
    /rotate\(\s*(-?[\d.]+)\s+(-?[\d.]+)\s+(-?[\d.]+)\s*\)/
  );
  if (n) {
    const e = parseFloat(n[1]), a = parseFloat(n[2]), s = parseFloat(n[3]), o = e * Math.PI / 180, i = Math.cos(o), r = Math.sin(o), c = a - a * i + s * r, d = s - a * r - s * i;
    return `matrix(${i} ${r} ${-r} ${i} ${c} ${d})`;
  }
  return t;
}
function en(t) {
  const n = t.match(
    /matrix\(([^,]+)\s+([^,]+)\s+([^,]+)\s+([^,]+)\s+([^,]+)\s+([^)]+)\)/
  );
  if (!n)
    return { scaleX: 1, scaleY: 1, translateX: 0, translateY: 0 };
  const [, e, , , a, s, o] = n.map(parseFloat);
  return {
    scaleX: e,
    scaleY: a,
    translateX: s,
    translateY: o
  };
}
function Io(t) {
  return `matrix(${t.scaleX} 0 0 ${t.scaleY} ${t.translateX} ${t.translateY})`;
}
function Po(t, n) {
  if (!t || !n)
    return { scaleX: 1, scaleY: 1, translateX: 0, translateY: 0 };
  const e = en(t), a = en(n), s = e.scaleX / a.scaleX, o = e.scaleY / a.scaleY, i = (e.translateX - a.translateX) / a.scaleX, r = (e.translateY - a.translateY) / a.scaleY;
  return { scaleX: s, scaleY: o, translateX: i, translateY: r };
}
function Wn(t) {
  const e = new DOMParser().parseFromString(
    `<svg>${t.info}</svg>`,
    "image/svg+xml"
  ), a = Array.from(e.documentElement.children);
  return a.length === 0 ? [] : a.map((o) => {
    var d;
    const i = o.tagName, r = {};
    for (let u = 0; u < o.attributes.length; u++) {
      const S = o.attributes.item(u);
      S && (S.name === "transform" ? r[S.name] = yo(S.value) : r[S.name] = Number.isNaN(Number(S.value)) ? S.value : Number(S.value));
    }
    const c = ((d = o.textContent) == null ? void 0 : d.trim()) || void 0;
    return {
      type: i,
      attributes: r,
      children: c
    };
  }).sort((o, i) => o.type === "text" && i.type !== "text" ? 1 : o.type !== "text" && i.type === "text" ? -1 : 0);
}
function Kn(t, n) {
  if (t.isEmpty() && n.length === 0)
    return { minX: 0, minY: 0, width: 0, height: 0 };
  let e = 1 / 0, a = -1 / 0, s = 1 / 0, o = -1 / 0;
  t.forEach((d) => {
    const u = typeof d.coordinates.X == "number" ? d.coordinates.X : parseFloat(d.coordinates.X), S = typeof d.coordinates.Y == "number" ? d.coordinates.Y : parseFloat(d.coordinates.Y), g = J.size * u, p = -30 * S;
    e = Math.min(e, g), a = Math.max(a, g), s = Math.min(s, p), o = Math.max(o, p);
  }), n.forEach((d) => {
    Wn(d).forEach(({ type: S, attributes: g }) => {
      switch (S) {
        case "line": {
          const p = Z(g.x1), f = Z(g.y1), m = Z(g.x2), L = Z(g.y2);
          e = Math.min(e, p, m), a = Math.max(a, p, m), s = Math.min(s, f, L), o = Math.max(o, f, L);
          break;
        }
        case "rect": {
          const p = Z(g.x), f = Z(g.y), m = Z(g.width), L = Z(g.height);
          e = Math.min(e, p), a = Math.max(a, p + m), s = Math.min(s, f), o = Math.max(o, f + L);
          break;
        }
        case "text": {
          const p = Z(g.x), f = Z(g.y);
          e = Math.min(e, p), a = Math.max(a, p), s = Math.min(s, f), o = Math.max(o, f);
          break;
        }
        case "circle": {
          const p = Z(g.cx), f = Z(g.cy), m = Z(g.r);
          e = Math.min(e, p - m), a = Math.max(a, p + m), s = Math.min(s, f - m), o = Math.max(o, f + m);
          break;
        }
      }
    });
  });
  const i = 50;
  e -= i, s -= i;
  const r = a - e + i * 2, c = o - s + i * 2;
  return { minX: e, minY: s, width: r, height: c };
}
function No(t) {
  if (!t || t.isEmpty())
    return !1;
  const n = t.first();
  return !!(n && n["@type"] === "AvailableSeat");
}
function ko({
  seat: t,
  participant: n,
  isDesk: e
}) {
  const { t: a } = Gt(), s = 28, o = cs(a, t);
  if (!o)
    return null;
  const i = rn(n), r = i && i.length > s ? `${i == null ? void 0 : i.slice(0, s)}...` : i;
  return /* @__PURE__ */ T("div", { children: [
    /* @__PURE__ */ l("div", { className: "bold", children: i && e ? a("tooltip_participant", {
      seat: o,
      participant: r
    }) : o }),
    /* @__PURE__ */ T("div", { className: "seatId", children: [
      "(SeatId: ",
      et(t["@id"]),
      ")"
    ] })
  ] });
}
let wo = class extends re {
  constructor(e) {
    super(e);
    // eslint-disable-next-line react/sort-comp
    H(this, "svgElement");
    H(this, "_bodyRef");
    this._bodyRef = null, this.svgElement = null, this.setBodyRef = this.setBodyRef.bind(this), this.getOffset = this.getOffset.bind(this), this.state = {
      height: 0,
      width: 0,
      offsetLeft: 0,
      offsetTop: 0
    };
  }
  componentDidMount() {
    this.svgElement = document.getElementById(
      "seatingSVG"
    );
    const { left: e, top: a } = this.getOffset();
    this.setState({
      offsetLeft: e,
      offsetTop: a
    }), this.svgElement.children[0].addEventListener("zoom", () => {
      this.setFontSizeFromScale();
    }), this.setFontSizeFromScale();
  }
  componentDidUpdate(e, a) {
    let s = !1;
    const o = {}, i = this.getUpdatedDimensions();
    if (i !== null) {
      const { height: c, width: d } = i;
      o.height = c, o.width = d;
    }
    const r = ["mouseX", "mouseY"];
    if (Object.keys(this.props).forEach((c) => {
      if (r.indexOf(c) < 0) {
        const d = this.props[c], u = e[c];
        d !== u && (s = !0);
      }
    }), // eslint-disable-next-line react/destructuring-assignment
    (a.height !== this.state.height || // eslint-disable-next-line react/destructuring-assignment
    a.width !== this.state.width) && (s = !0), s) {
      const { left: c, top: d } = this.getOffset();
      o.offsetLeft = c, o.offsetTop = d;
    }
    Object.keys(o).length > 0 && this.setState(o);
  }
  setBodyRef(e) {
    e !== this._bodyRef && e && (this._bodyRef = e, this.setState({
      height: e.offsetHeight,
      width: e.offsetWidth
    }));
  }
  /**
   * We must compute the fontSize depending on the scale
   * because a flat value would scale alongside the svg
   * Same for the offsetLeft
   */
  setFontSizeFromScale() {
    if (this._bodyRef === null)
      return;
    const { scale: e } = Ge().getTransform();
    this._bodyRef.style.fontSize = `${1 / e}em`;
  }
  getUpdatedDimensions() {
    if (!this._bodyRef)
      return null;
    const { height: e, width: a } = this.state, s = this._bodyRef.offsetHeight, o = this._bodyRef.offsetWidth;
    return s !== e || o !== a ? {
      height: s,
      width: o
    } : null;
  }
  getOffset() {
    const { seat: e, mouseY: a, mouseX: s } = this.props;
    let o = 0, i = 0;
    if (this._bodyRef !== null && this.svgElement !== null) {
      const r = e["@id"].replace("/v1/seats/", ""), c = document.getElementById(r), d = this._bodyRef.getBoundingClientRect().height, u = this._bodyRef.getBoundingClientRect().width, S = c ? c.clientHeight : 0, g = c ? c.clientWidth : 0, p = d + S, f = u + g, m = this.svgElement.getBoundingClientRect(), L = a - p < m.top, b = a + p > m.top + m.height, A = s - f < m.left, P = s + f > m.left + m.width, k = !L && !A && !P, V = A, nt = L && !b;
      k ? (o = this._bodyRef.offsetHeight + 10, i = this._bodyRef.offsetWidth / 2) : nt ? (o = this._bodyRef.offsetHeight - J.size - 85, i = this._bodyRef.offsetWidth / 2) : V ? (i -= J.size, o = J.size / 2) : (i += this._bodyRef.offsetWidth + J.size, o = J.size / 2), !k && !nt && (b ? o = this._bodyRef.offsetHeight + 20 : L && (o = this._bodyRef.offsetHeight - J.size));
    }
    return {
      left: i,
      top: o
    };
  }
  getPosX() {
    const { seat: e } = this.props, a = typeof e.coordinates.X == "number" ? e.coordinates.X : parseFloat(e.coordinates.X);
    return J.size * a;
  }
  getPosY() {
    const { seat: e } = this.props;
    return -30 * (typeof e.coordinates.Y == "number" ? e.coordinates.Y : parseFloat(e.coordinates.Y));
  }
  render() {
    const { seat: e, participant: a, isDesk: s } = this.props, { height: o, width: i, offsetTop: r, offsetLeft: c } = this.state;
    if (e === null || e.type === q.STANDING)
      return /* @__PURE__ */ l("g", {});
    const d = this.getPosX() - c, u = this.getPosY() - r;
    return /* @__PURE__ */ l("g", { transform: `translate(${d} ${u - 5})`, children: /* @__PURE__ */ l("foreignObject", { width: i, height: o, children: /* @__PURE__ */ l(
      "div",
      {
        className: Wt("mpd-seating__tooltip", {
          "mpd-seating__tooltip--is-desk": s
        }),
        ref: this.setBodyRef,
        children: /* @__PURE__ */ l(
          ko,
          {
            seat: e,
            participant: a,
            isDesk: s
          }
        )
      }
    ) }) });
  }
};
function Ro(t) {
  const { currentDomain: n } = Ft(), e = n === X.DESK;
  return /* @__PURE__ */ l(wo, G(w({}, t), { isDesk: e }));
}
const Go = (t, n) => {
  const { seatId: e } = n, a = t.seating.get("seatList"), s = `/v1/seats/${e}`, o = (a || M()).find(
    (i) => i["@id"] === s
  );
  if (typeof o == "undefined")
    throw new Error(`Unable to find seat with id ${e}`);
  return {
    seat: o
  };
}, Oo = pa(Go)(Ro);
function nn({
  id: t,
  children: n,
  onZoom: e,
  type: a
}) {
  return /* @__PURE__ */ l(
    "button",
    {
      type: "button",
      id: t,
      className: `mpd-btn mpd-btn--icon-only zoom-button zoom-button--${a}`,
      onClick: e,
      children: n
    }
  );
}
function Do({ zoomIn: t, zoomOut: n }) {
  return /* @__PURE__ */ T("div", { className: "mpd-btn-group", children: [
    /* @__PURE__ */ l(nn, { onZoom: t, id: "zoomIn-button", type: "zoomIn", children: /* @__PURE__ */ l(St, { icon: "plus-stroke", width: "20" }) }),
    /* @__PURE__ */ l(nn, { onZoom: n, id: "zoomOut-button", type: "zoomOut", children: /* @__PURE__ */ l(St, { icon: "minus-stroke", width: "20" }) })
  ] });
}
const Mo = ra(
  ({ id: t = null, info: n }, e) => {
    const a = {};
    return t !== null && (a.id = t), /* @__PURE__ */ l(
      "g",
      G(w({
        ref: e
      }, a), {
        className: "mpd-seating__config__block",
        dangerouslySetInnerHTML: { __html: n }
      })
    );
  }
);
function Bo(t, n, e, a) {
  return Pa(t) ? e === X.DESK && n === O.Contingent && t.stockContingent && typeof t.stockContingent == "object" && t.stockContingent.color || lt : Kt(t) && e === X.DESK && t.bookingStatus === C.SCANNED ? xn : e === X.MINISITE || e === X.DESK && n !== O.Contingent ? (I(t.seatGroup, "seatEntity.seatGroup"), a.get(Lt(t.seatGroup)) || lt) : Kt(t) && e === X.DESK && n === O.Contingent && t.stockContingent && typeof t.stockContingent == "object" ? t.stockContingent.color || lt : Ie(t) && e === X.DESK && n === O.Contingent && t.contingent && typeof t.contingent == "object" && t.contingent.color || lt;
}
class De extends re {
  render() {
    const {
      isMovingSeat: n,
      onClickSeat: e,
      onFocusSeat: a,
      onUnfocusSeat: s,
      seatEntityList: o,
      SeatElement: i,
      seatById: r,
      selectableSeatIdSet: c,
      selectedSeatIdSet: d,
      selectedView: u,
      currentDomain: S,
      seatGroupColorMap: g,
      getTicketPriceListBySeatGroup: p,
      renderingNameContext: f
    } = this.props, m = S === X.DESK;
    return o.map((L) => {
      const b = Ds(L, r), A = Number(b["@id"].replace("/v1/seats/", ""));
      return /* @__PURE__ */ l(
        i,
        {
          renderingNameContext: f,
          seatEntity: L,
          coordinates: b.coordinates,
          label: b.label,
          angle: b.angle,
          type: b.type,
          hasObstructedView: b.hasObstructedView,
          seatId: A,
          isSelectable: c.has(b["@id"]),
          isSelected: !!(d != null && d.has(A)),
          bookingStatus: Kt(L) && L.bookingStatus || Ie(L) && L.status || C.AVAILABLE,
          color: Bo(
            L,
            u,
            S,
            g
          ),
          isDesk: m,
          isMovingSeat: n,
          onClickSeat: e,
          onFocusSeat: a,
          onUnfocusSeat: s,
          getTicketPriceListBySeatGroup: p
        },
        L["@id"]
      );
    });
  }
}
H(De, "defaultProps", {
  getTicketPriceListBySeatGroup: null
});
function Fo(t) {
  const n = B(An), { selectedView: e } = Oe(), { currentDomain: a } = Ft(), s = Dn(), o = Un();
  return /* @__PURE__ */ l(
    De,
    G(w({}, t), {
      renderingNameContext: o,
      seatById: s,
      seatGroupColorMap: n,
      selectedView: e,
      currentDomain: a
    })
  );
}
var rt = /* @__PURE__ */ ((t) => (t.SEATING_PLAN_PURCHASE = "SeatingPlanPurchase", t.CART_REPLACEMENT = "CartReplacement", t.ORDER_REPLACEMENT = "OrderReplacement", t.LOGICAL_SEAT_CONFIG_ADMIN = "LogicalSeatConfigAdmin", t.STOCK_MANAGEMENT = "StockManagement", t.ORDER_VIEWER = "OrderViewer", t.SEATING_PLAN_VIEWER = "SeatingPlanViewer", t.ORDER_MANAGEMENT = "OrderManagement", t.MULTI_CONTEXT_PLAN = "MultiContextPlan", t.PLAN_EDITOR = "PlanEditor", t.SEATING_PLAN_SPECTATOR = "SeatingPlanSpectator", t))(rt || {});
const xo = (t, n) => {
  switch (n) {
    case rt.CART_REPLACEMENT:
      return t("seating_plan.toolbar.CartReplacement");
    case rt.ORDER_REPLACEMENT:
      return t("seating_plan.toolbar.OrderReplacement");
    case rt.ORDER_VIEWER:
      return t("seating_plan.toolbar.OrderViewer");
    case rt.SEATING_PLAN_VIEWER:
      return t("seating_plan.toolbar.SeatingPlanViewer");
    case rt.ORDER_MANAGEMENT:
      return t("seating_plan.toolbar.OrderManagement");
    case rt.SEATING_PLAN_PURCHASE:
      return t("seating_plan.toolbar.SeatingPlanPurchase");
    case rt.STOCK_MANAGEMENT:
      return t("seating_plan.toolbar.StockManagement");
    default:
      return console.error(`Unable to get name for component ${n}.`), n;
  }
};
function Vo({
  actionButtons: t = null
}) {
  const { t: n } = Gt(), { elementList: e, hiddenPlanContext: a, selectedIndex: s, onSelect: o } = go(), i = Object.keys(e).filter((r) => !a.includes(r));
  return /* @__PURE__ */ T("div", { className: "mpd-seating__bottom-toolbar", children: [
    i.length > 0 && /* @__PURE__ */ l("div", { className: "mpd-btn-group", children: i.map((r) => /* @__PURE__ */ l(
      "button",
      {
        type: "button",
        className: Wt("mpd-btn", {
          selected: r === s
        }),
        onClick: () => o(r),
        children: xo(n, r)
      },
      r
    )) }),
    t
  ] });
}
function zo({ contingentEntityList: t }) {
  return /* @__PURE__ */ l(Mt, { children: t.map((n) => {
    let e = lt, a = "";
    return Na(n) ? (E(
      n.contingent,
      "stockContingent.contingent"
    ), e = n.contingent.color, a = n.contingent.name || "") : (e = n.color, a = n.name || ""), /* @__PURE__ */ T("div", { className: "legend-item", children: [
      /* @__PURE__ */ l(
        St,
        {
          icon: "seat-filled",
          width: "12",
          color: e != null ? e : lt
        }
      ),
      /* @__PURE__ */ l("span", { className: "bold small ml2", children: a })
    ] }, n["@id"]);
  }) });
}
function Uo({ seatGroupList: t, className: n }) {
  return /* @__PURE__ */ l(Mt, { children: t.map((e) => /* @__PURE__ */ T("div", { className: Wt("legend-item", n), children: [
    /* @__PURE__ */ l(
      St,
      {
        icon: "seat-filled",
        width: "12",
        color: e.seatColor || lt
      }
    ),
    /* @__PURE__ */ l("span", { className: "bold small ml2", children: e.label })
  ] }, e["@id"])) });
}
const Zn = Bt(
  void 0
);
function $o({
  children: t
}) {
  const [n, e] = Xt(""), [a, s] = Xt("");
  Pt(() => {
    let r;
    const c = () => {
      const d = document.getElementById("seatingSVG");
      if (!d) {
        setTimeout(c, 500);
        return;
      }
      const u = d.children[0];
      if (!(u instanceof SVGGElement))
        return;
      const S = u.getAttribute("transform") || "";
      s(S), e(S), r = new MutationObserver(() => {
        const g = u.getAttribute("transform") || "";
        e(g);
      }), r.observe(u, {
        attributes: !0,
        attributeFilter: ["transform"]
      });
    };
    return setTimeout(c, 1e3), () => {
      r == null || r.disconnect();
    };
  }, []);
  const o = ae(
    () => Po(n, a),
    [n, a]
  ), i = ae(
    () => ({
      initialTransform: a,
      currentTransform: n,
      relativeTransform: o
    }),
    [a, n, o]
  );
  return /* @__PURE__ */ l(Zn.Provider, { value: i, children: t({ relativeTransform: o }) });
}
function $r() {
  const t = jt(Zn);
  if (!t)
    throw new Error(
      "useSeatingTransformContext must be used within a SeatingTransformProvider"
    );
  return t;
}
const jn = Ce(
  ({
    renderingNameContext: t,
    isSelected: n,
    coordinates: e,
    label: a,
    bookingStatus: s,
    type: o,
    color: i,
    hasObstructedView: r
  }) => {
    const c = J.iconSize, d = t !== rt.SEATING_PLAN_PURCHASE;
    let u = d ? "white" : i, S = d ? "black" : "white", g = "#cccccc";
    if (n && (u = "black", S = "white", g = "#333333"), s === C.DISMISSED)
      return null;
    const p = Yn(e.X) + c / 2, f = Hn(e.Y) + c / 2, m = c / 2, L = [];
    if (r)
      for (let A = p - m + 3; A < p + m; A += 3) {
        const P = A - p, k = Math.sqrt(m * m - P * P);
        L.push(
          /* @__PURE__ */ l(
            hn,
            {
              x1: A,
              y1: f - k + 1,
              x2: A,
              y2: f + k - 1,
              stroke: g,
              strokeWidth: "1"
            },
            A
          )
        );
      }
    return /* @__PURE__ */ T(oe, { children: [
      /* @__PURE__ */ l(
        fn,
        {
          cx: p,
          cy: f,
          r: m,
          fill: u,
          stroke: "black",
          strokeWidth: "1",
          strokeDasharray: o === q.FOLDABLE ? "2,2" : void 0
        }
      ),
      r && /* @__PURE__ */ l(oe, { children: L }),
      /* @__PURE__ */ l(
        N,
        {
          x: p,
          y: f + 2,
          fill: S,
          textAnchor: "middle",
          style: Yo.text,
          children: a == null ? void 0 : a.toUpperCase()
        }
      )
    ] });
  }
), Yo = Vt.create({
  text: {
    fontSize: 8
  }
});
jn.displayName = "PdfSeat";
const an = [
  "ticketPriceName",
  "ticketPriceType",
  "facialValue",
  "currency",
  "barcode",
  {
    availableSeat: In
  },
  { participant: ["crmId", "firstname", "lastname"] }
], Ho = [
  "@id",
  "entityId",
  "entityName",
  {
    bookingItemList: ["seatId"]
  }
], Yr = [
  "@id",
  "createdAt",
  "originType",
  "status",
  "description",
  "currency",
  "contract",
  "comment",
  "retailValue",
  "nbTickets",
  "nbCoupons",
  "hasMovableSeats",
  {
    orderItemList: [
      {
        ticketList: an
      },
      {
        ticketPrice: [{ ticketPriceSeatGroupList: ["seatGroup"] }]
      }
    ]
  },
  { customer: ["firstname", "lastname", "email", "phone", "crmId"] },
  {
    cartItemWithOfferList: ["facialValue", "facialFeeValue", "quantity"]
  },
  {
    payment: [
      "@id",
      "customerPaidAmount",
      {
        paymentMethodList: ["name", "customerPaidAmount", "valueDate"]
      },
      {
        wallet: ["contract"]
      }
    ]
  },
  {
    ticketList: an
  },
  { sellingDevice: ["isExternalProvider"] }
];
function Me(t, n, e = !1) {
  return Et(t.cartItemList, "cart.cartItemList"), t.set(
    "cartItemList",
    t.cartItemList.map((a) => (Et(
      a.availableSeatList,
      "cartItem.availableSeatList"
    ), a.set(
      "availableSeatList",
      a.availableSeatList.filter(
        (s) => s.eventDate === Rn("/v1/event_dates/", n)
      )
    ))).filter((a) => {
      var s, o;
      return e ? ((o = (s = a.availableSeatList) == null ? void 0 : s.size) != null ? o : 0) > 0 : !0;
    })
  );
}
function Be(t, n) {
  return Et(t.ticketList, "order.ticketList"), t.set(
    "ticketList",
    t.ticketList.filter(
      (e) => e.availableSeat !== null && typeof e.availableSeat == "object" && e.availableSeat.eventDate === Rn("/v1/event_dates/", n)
    )
  );
}
const Hr = [
  "@id",
  "reservationName",
  "createdAt",
  "currency",
  "bookTickets",
  "originType",
  "comment",
  "nbTickets",
  "retailValue",
  "type",
  "hasMovableSeats",
  {
    cartItemList: [
      "seatList",
      {
        ticketPrice: [
          "name",
          "facialValue",
          "currency",
          { ticketPriceSeatGroupList: ["seatGroup"] }
        ]
      },
      {
        availableSeatList: In
      },
      {
        participant: ["firstname", "lastname"]
      }
    ]
  },
  { customer: ["firstname", "lastname", "email", "crmId"] },
  {
    cartItemWithOfferList: ["facialValue", "facialFeeValue", "quantity"]
  },
  { sellingDevice: ["isExternalProvider", "originType"] }
];
function Xr() {
  return {
    type: Ua
  };
}
function Wr({
  dispatch: t,
  eventDateId: n,
  contractId: e,
  currentPage: a,
  getFirstPage: s,
  itemsPerPage: o,
  search: i = ""
}) {
  const r = s ? 1 : a + 1;
  t({
    type: Ga,
    page: r,
    search: i
  });
  const c = Ho.slice(0);
  c.push({
    cart: ["@id", { customer: ["firstname", "lastname", "email", "crmId"] }]
  }), c.push({
    order: [
      "@id",
      { customer: ["firstname", "lastname", "email", "phone", "crmId"] }
    ]
  });
  const d = {
    eventDate: n,
    itemsPerPage: o,
    page: r,
    "order[scanned]": "ASC",
    "order[name]": "ASC",
    "order[createdAt]": "DESC",
    contract: e,
    type: [We.RESERVATION, We.ORDER].join(
      ","
    )
  };
  return i && (d.q = i), R.getSdk().getRepository("booking").findBy(d, c).then((u) => {
    const S = u.getMembers().map((g) => {
      if (g.order !== null) {
        E(g.order, "booking.order");
        const p = Be(
          g.order,
          n
        );
        return g.set("order", p);
      }
      if (g.cart !== null) {
        E(g.cart, "booking.cart");
        const p = Me(
          g.cart,
          n
        );
        return g.set("cart", p);
      }
      return g;
    });
    return u.set("hydra:member", S);
  }).then(
    (u) => u.set(
      "hydra:member",
      u.getMembers().filter((S) => !(S.order !== null && typeof S.order == "object" && S.order.status === "refunded_totally"))
    )
  ).then((u) => t({
    type: Oa,
    bookingCollection: u,
    page: r,
    search: i
  })).catch((u) => (u instanceof _a && u.baseResponse.json().then((S) => t({
    type: qe,
    status: "",
    error: S["hydra:description"]
  })), t({
    type: qe,
    status: "",
    error: u == null ? void 0 : u.message
  })));
}
function Xo({
  booking: t,
  eventDateId: n
}) {
  var u, S, g, p, f, m;
  const { t: e } = Gt();
  if (!t)
    return /* @__PURE__ */ l(y, {});
  const { order: a, cart: s } = t;
  Y(a, "booking.order"), Y(s, "booking.cart");
  const o = (S = (u = a == null ? void 0 : a.customer) != null ? u : s == null ? void 0 : s.customer) != null ? S : null;
  Y(o, "booking.order.customer");
  const i = rn(o), r = a && n ? Be(a, n) : a, c = s && n ? Me(s, n, !0) : s, d = (m = (f = (g = r == null ? void 0 : r.ticketList) == null ? void 0 : g.size) != null ? f : (p = c == null ? void 0 : c.cartItemList) == null ? void 0 : p.size) != null ? m : 0;
  return /* @__PURE__ */ T(N, { children: [
    !!i && `${i} (`,
    a && e("sales.list_header.order", {
      number: a.getShortId()
    }),
    (s == null ? void 0 : s.type) === Ke.RESERVATION && e("sales.reservation", { number: s.getShortId() }),
    (s == null ? void 0 : s.type) === Ke.CART && e("sales.carts", { number: s.getShortId() }),
    !!i && ")",
    d > 0 && ` - ${e("order.nb_tickets", {
      count: d
    })}`
  ] });
}
const sn = Vt.create({
  container: {
    fontFamily: "Helvetica",
    fontSize: 15,
    fontWeight: "bold",
    backgroundColor: "#f7f5f7",
    padding: 15,
    flexGrow: 1
  },
  copyright: {
    fontSize: 7,
    textAlign: "right",
    marginBottom: 5
  }
});
function qn({
  pdfInfo: t,
  focusedBooking: n,
  seatConfig: e
}) {
  var o, i;
  const a = t.eventDateStartDate ? new Date(t.eventDateStartDate) : null, s = (/* @__PURE__ */ new Date()).toLocaleString(Xe(), {
    dateStyle: "short",
    timeStyle: "short",
    timeZone: (o = t.ticketingTimezone) != null ? o : void 0
  });
  return /* @__PURE__ */ T(Mt, { children: [
    /* @__PURE__ */ l(y, { children: /* @__PURE__ */ l(N, { style: sn.copyright, children: `Mapado - ${s}` }) }),
    /* @__PURE__ */ T(y, { style: sn.container, children: [
      n && /* @__PURE__ */ l(
        Xo,
        {
          eventDateId: t.eventDateId,
          booking: n
        }
      ),
      /* @__PURE__ */ l(N, { children: `| ${t.ticketingTitle}` }),
      a && /* @__PURE__ */ T(N, { children: [
        "| ",
        a.toLocaleString(Xe(), {
          dateStyle: "long",
          timeStyle: "short",
          timeZone: (i = t.ticketingTimezone) != null ? i : void 0
        })
      ] }),
      e && /* @__PURE__ */ l(N, { children: `@ ${e.label}` }),
      t.contingentName && /* @__PURE__ */ l(N, { children: W.t("pdf.header.contingent_name", {
        contingentName: t.contingentName
      }) }),
      t.seatGroupName && /* @__PURE__ */ l(N, { children: W.t("pdf.header.seat_group_name", {
        name: t.seatGroupName
      }) })
    ] })
  ] });
}
function on({
  children: t,
  pdfInfo: n,
  booking: e,
  seatConfig: a
}) {
  return /* @__PURE__ */ T(Le, { size: "A4", style: Wo.page, children: [
    /* @__PURE__ */ l(y, { children: /* @__PURE__ */ l(
      qn,
      {
        pdfInfo: n,
        focusedBooking: e,
        seatConfig: a
      }
    ) }),
    t
  ] });
}
const Wo = Vt.create({
  page: {
    padding: 10
  }
}), v = Vt.create({
  table: {
    width: "auto",
    borderStyle: "solid",
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderTopWidth: 1,
    borderLeftWidth: 1,
    borderColor: "#bfbfbf",
    marginTop: 10
  },
  tableRow: {
    flexDirection: "row"
  },
  tableNarrowCol: {
    flex: 1,
    borderStyle: "solid",
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderColor: "#bfbfbf",
    padding: 5
  },
  tableCol: {
    flex: 2,
    borderStyle: "solid",
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderColor: "#bfbfbf",
    padding: 5
  },
  tableCell: {
    fontSize: 10
  }
});
function Ko({
  booking: t,
  seatConfig: n,
  eventDateId: e
}) {
  var L;
  const { order: a, cart: s } = t != null ? t : { order: null, cart: null };
  Y(a, "booking.order"), Y(s, "booking.cart");
  const o = Te(
    (b) => {
      var A;
      return a ? (Ze(
        a.ticketList,
        "booking.order.ticketList"
      ), (A = a.ticketList.find((P) => {
        var k;
        return Y(
          P.availableSeat,
          "ticket.availableSeat"
        ), ((k = P.availableSeat) == null ? void 0 : k["@id"]) === b["@id"];
      })) == null ? void 0 : A.barcode) : null;
    },
    [a]
  );
  if (!t)
    return /* @__PURE__ */ l(y, {});
  const i = a && e ? ce(
    Be(a, e)
  ) : null, r = s && e ? qt(
    Me(s, e, !0)
  ) : null, c = (L = i != null ? i : r) != null ? L : M();
  Ze(
    c,
    "booking.order.availableSeatList or booking.cart.availableSeatList"
  );
  const d = c.some(
    (b) => (E(b.seat, "ticket.availableSeat.seat"), !!b.seat.zone)
  ), u = c.some(
    (b) => (E(b.seat, "ticket.availableSeat.seat"), !!b.seat.floor)
  ), S = c.sort(
    (b, A) => {
      var nt, Fe, xe, Ve;
      const P = b.seat, k = A.seat;
      E(P, "seatA"), E(k, "seatB");
      const V = ((nt = P.row) != null ? nt : "").localeCompare((Fe = k.row) != null ? Fe : "");
      return V !== 0 ? V : ((xe = P.seatNumber) != null ? xe : "").localeCompare((Ve = k.seatNumber) != null ? Ve : "");
    }
  ), g = Q(
    n.floorList.map((b) => [b["@id"], b])
  ), p = (b) => {
    if (b != null && b.floor)
      return tt(b.floor, "seat.floor"), g.get(b.floor);
  }, f = Q(n.zoneList.map((b) => [b["@id"], b])), m = (b) => {
    if (b != null && b.zone)
      return tt(b.zone, "seat.zone"), f.get(b.zone);
  };
  return /* @__PURE__ */ T(y, { style: v.table, children: [
    /* @__PURE__ */ T(y, { style: v.tableRow, children: [
      /* @__PURE__ */ l(y, { style: v.tableNarrowCol, children: /* @__PURE__ */ l(N, { style: v.tableCell, children: W.t("pdf.detail.row") }) }),
      /* @__PURE__ */ l(y, { style: v.tableNarrowCol, children: /* @__PURE__ */ l(N, { style: v.tableCell, children: W.t("pdf.detail.seat") }) }),
      /* @__PURE__ */ l(y, { style: v.tableCol, children: /* @__PURE__ */ l(N, { style: v.tableCell, children: W.t("pdf.detail.category") }) }),
      d && /* @__PURE__ */ l(y, { style: v.tableCol, children: /* @__PURE__ */ l(N, { style: v.tableCell, children: W.t("pdf.detail.zone") }) }),
      u && /* @__PURE__ */ l(y, { style: v.tableCol, children: /* @__PURE__ */ l(N, { style: v.tableCell, children: W.t("pdf.detail.floor") }) }),
      !!a && /* @__PURE__ */ l(y, { style: v.tableCol, children: /* @__PURE__ */ l(N, { style: v.tableCell, children: W.t("pdf.detail.barcode") }) })
    ] }),
    S.map((b) => {
      var k, V;
      const { seat: A, seatGroup: P } = b;
      return E(A, "ticket.availableSeat.seat"), E(P, "ticket.availableSeat.seatGroup"), /* @__PURE__ */ T(y, { style: v.tableRow, children: [
        /* @__PURE__ */ l(y, { style: v.tableNarrowCol, children: /* @__PURE__ */ l(N, { style: v.tableCell, children: A.row }) }),
        /* @__PURE__ */ l(y, { style: v.tableNarrowCol, children: /* @__PURE__ */ l(N, { style: v.tableCell, children: A.seatNumber }) }),
        /* @__PURE__ */ l(y, { style: v.tableCol, children: /* @__PURE__ */ l(N, { style: v.tableCell, children: P.label }) }),
        d && /* @__PURE__ */ l(y, { style: v.tableCol, children: /* @__PURE__ */ l(N, { style: v.tableCell, children: (k = m(A)) == null ? void 0 : k.name }) }),
        u && /* @__PURE__ */ l(y, { style: v.tableCol, children: /* @__PURE__ */ l(N, { style: v.tableCell, children: (V = p(A)) == null ? void 0 : V.name }) }),
        !!a && /* @__PURE__ */ l(y, { style: v.tableCol, children: /* @__PURE__ */ l(N, { style: v.tableCell, children: o(b) }) })
      ] }, b["@id"]);
    })
  ] });
}
function Zo({
  availableSeatList: t,
  selectedView: n
}) {
  var o;
  const e = (o = t == null ? void 0 : t.filter(
    (i) => i.bookingStatus !== C.DISMISSED
  )) != null ? o : M(), a = (i) => {
    var d, u;
    if (n === O.SeatGroup)
      return E(
        i.seatGroup,
        "availableSeat.seatGroup"
      ), {
        id: i.seatGroup["@id"],
        label: i.seatGroup.label
      };
    const { stockContingent: r } = i;
    if (Y(
      r,
      "availableSeat.stockContingent"
    ), !r)
      return {
        id: ve,
        label: W.t("pdf.detail.no_contingent")
      };
    if (typeof r == "string")
      throw new Error("availableSeat.stockContingent should be an object");
    const { contingent: c } = r;
    if (typeof c != "object" || c === null)
      throw new Error(
        "availableSeat.stockContingent.contingent should be an object"
      );
    return {
      id: (d = c["@id"]) != null ? d : "",
      label: (u = c.name) != null ? u : ""
    };
  }, s = e.reduce(
    (i, r) => {
      const c = a(r), d = i.get(c.id);
      return d ? i.set(c.id, {
        name: d.name,
        quantity: d.quantity + 1
      }) : i.set(c.id, { name: c.label, quantity: 1 });
    },
    Q()
  );
  return /* @__PURE__ */ T(y, { style: v.table, children: [
    /* @__PURE__ */ T(y, { style: v.tableRow, children: [
      /* @__PURE__ */ l(y, { style: v.tableNarrowCol, children: /* @__PURE__ */ l(N, { style: v.tableCell, children: n === O.SeatGroup ? W.t("pdf.detail.category") : W.t("pdf.detail.contingent") }) }),
      /* @__PURE__ */ l(y, { style: v.tableNarrowCol, children: /* @__PURE__ */ l(N, { style: v.tableCell, children: W.t("pdf.detail.total") }) })
    ] }),
    s.map((i, r) => r === null ? null : (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ T(y, { style: v.tableRow, children: [
        /* @__PURE__ */ l(y, { style: v.tableNarrowCol, children: /* @__PURE__ */ l(N, { style: v.tableCell, children: i.name }) }),
        /* @__PURE__ */ l(y, { style: v.tableNarrowCol, children: /* @__PURE__ */ l(N, { style: v.tableCell, children: i.quantity }) })
      ] }, r)
    )).valueSeq(),
    /* @__PURE__ */ T(y, { style: v.tableRow, children: [
      /* @__PURE__ */ l(y, { style: v.tableNarrowCol, children: /* @__PURE__ */ l(N, { style: v.tableCell, children: W.t("pdf.detail.total") }) }),
      /* @__PURE__ */ l(y, { style: v.tableNarrowCol, children: /* @__PURE__ */ l(N, { style: v.tableCell, children: e.size }) })
    ] })
  ] });
}
function jo(s) {
  var o = s, {
    renderingNameContext: t,
    booking: n,
    pdfInfo: e
  } = o, a = be(o, [
    "renderingNameContext",
    "booking",
    "pdfInfo"
  ]);
  const { eventDateId: i } = e, r = {
    pdfInfo: e,
    booking: n != null ? n : null,
    seatConfig: a.seatConfig
  };
  switch (t) {
    case rt.ORDER_MANAGEMENT:
      return n ? (
        // eslint-disable-next-line react/jsx-props-no-spreading
        /* @__PURE__ */ l(on, G(w({}, r), { children: /* @__PURE__ */ l(
          Ko,
          w({
            eventDateId: i
          }, a)
        ) }))
      ) : null;
    case rt.SEATING_PLAN_PURCHASE:
      return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        /* @__PURE__ */ l(on, G(w({}, r), { children: /* @__PURE__ */ l(
          Zo,
          w({}, a)
        ) }))
      );
    default:
      return null;
  }
}
function qo({
  type: t,
  attributes: n,
  children: e
}) {
  switch (t) {
    case "line":
      return /* @__PURE__ */ l(hn, G(w({}, Qo(n)), { children: e }));
    case "rect":
      return /* @__PURE__ */ l(ba, G(w({}, ti(n)), { children: e }));
    case "text":
      return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        /* @__PURE__ */ l(N, G(w({}, ei(n)), { style: Jo.text, children: typeof e == "string" ? (
          // because text style is not handled well in SVG : https://github.com/diegomura/react-pdf/issues/3248
          e.toLocaleUpperCase()
        ) : e }))
      );
    case "circle":
      return /* @__PURE__ */ l(fn, G(w({}, ni(n)), { children: e }));
    default:
      return console.warn(
        `Unsupported SVG element type: ${t}, rendering raw HTML.`
      ), /* @__PURE__ */ l(oe, {});
  }
}
const Jo = Vt.create({
  text: {
    textAnchor: "middle",
    textTransform: "uppercase",
    letterSpacing: "5"
  }
});
function st(t, n) {
  if (typeof t == "string")
    return typeof n == "undefined" || n.includes(t) ? t : void 0;
}
function ge(t) {
  const {
    fill: n,
    color: e,
    stroke: a,
    transform: s,
    strokeDasharray: o,
    opacity: i,
    strokeWidth: r,
    fillOpacity: c,
    fillRule: d,
    strokeOpacity: u,
    textAnchor: S,
    strokeLinecap: g,
    strokeLinejoin: p,
    visibility: f,
    clipPath: m,
    dominantBaseline: L
  } = t;
  return te({
    // transparent is not handled well in react-pdf, so we force white color
    fill: n === "transparent" ? "#FFFFFF" : st(n),
    color: st(e),
    stroke: st(a),
    transform: st(s),
    strokeDasharray: st(o),
    opacity: i,
    strokeWidth: r,
    fillOpacity: c,
    fillRule: st(d, ["nonzero", "evenodd"]),
    strokeOpacity: u,
    textAnchor: st(S, ["start", "middle", "end"]),
    strokeLinecap: st(g, ["butt", "round", "square"]),
    strokeLinejoin: st(p, [
      "butt",
      "round",
      "square",
      "miter",
      "bevel"
    ]),
    visibility: st(f, ["visible", "hidden", "collapse"]),
    clipPath: st(m),
    dominantBaseline: st(L, [
      "auto",
      "middle",
      "central",
      "hanging",
      "mathematical",
      "text-after-edge",
      "text-before-edge"
    ])
  });
}
function Qo(t) {
  const { x1: n, y1: e, x2: a, y2: s } = t;
  return te(G(w({}, ge(t)), {
    x1: n,
    y1: e,
    x2: a,
    y2: s
  }));
}
function ti(t) {
  const { x: n, y: e, width: a, height: s, rx: o, ry: i } = t;
  return te(G(w({}, ge(t)), {
    x: n,
    y: e,
    width: a,
    height: s,
    rx: o,
    ry: i
  }));
}
function ei(t) {
  const { x: n, y: e } = t;
  return te(G(w({}, ge(t)), {
    x: n,
    y: e
  }));
}
function ni(t) {
  const { cx: n, cy: e, r: a } = t;
  return te(G(w({}, ge(t)), {
    cx: n,
    cy: e,
    r: a
  }));
}
function te(t) {
  return Object.fromEntries(
    Object.entries(t).filter(([, n]) => n !== void 0)
  );
}
function ai({
  seatConfigBlock: t
}) {
  const n = Wn(t);
  return /* @__PURE__ */ l(Mt, { children: n.map(({ type: e, attributes: a, children: s }, o) => /* @__PURE__ */ l(
    qo,
    {
      type: e,
      attributes: a,
      children: s
    },
    `${t["@id"]}-${o}`
  )) });
}
function si(t, n, e) {
  return e ? Re(e).map((a) => (E(a.seat, "availableSeat.seat"), Number(a.seat.getShortId()))).toSet() : n && No(t) ? t.filter(
    (a) => a.seatGroup && Lt(a.seatGroup) === n
  ).map(
    (a) => a.seat ? Number(et(Lt(a.seat))) : -1
  ).toSet() : null;
}
function Jn({
  pdfInfo: t,
  renderingNameContext: n,
  relativeTransform: e,
  availableSeatList: a,
  seatList: s,
  seatConfig: o,
  focusedBooking: i,
  selectedSeatIdSet: r,
  seatById: c,
  seatGroupColorMap: d,
  selectedView: u,
  withPreview: S = !1
}) {
  var V;
  const g = a != null ? a : s, p = si(
    g,
    t.seatGroupId,
    i
  ), f = (V = o == null ? void 0 : o.seatConfigBlockList) != null ? V : [];
  if (!g || !s || !o)
    return /* @__PURE__ */ l(je, { children: /* @__PURE__ */ l(Le, { size: "A4", children: /* @__PURE__ */ l(y, {}) }) });
  const m = Kn(s, f), L = 595.28, b = m.height / m.width, A = L, P = A * b, k = /* @__PURE__ */ T(
    je,
    {
      title: W.t("pdf.document.title", { seatConfig: o == null ? void 0 : o.label }),
      children: [
        /* @__PURE__ */ T(Le, { size: "A4", style: oi.page, children: [
          /* @__PURE__ */ l(y, { children: /* @__PURE__ */ l(
            qn,
            {
              pdfInfo: t,
              focusedBooking: i,
              seatConfig: o
            }
          ) }),
          /* @__PURE__ */ l(
            Ea,
            {
              preserveAspectRatio: "xMaxYMax",
              id: "seatingSVG",
              viewBox: `${m.minX} ${m.minY} ${m.width} ${m.height}`,
              width: A,
              height: P,
              children: /* @__PURE__ */ T(oe, { transform: Io(e), children: [
                f.map((nt) => /* @__PURE__ */ l(
                  ai,
                  {
                    seatConfigBlock: nt
                  },
                  nt["@id"]
                )),
                /* @__PURE__ */ l(
                  De,
                  {
                    SeatElement: jn,
                    renderingNameContext: n,
                    isMovingSeat: !1,
                    seatEntityList: g,
                    selectableSeatIdSet: K(),
                    selectedSeatIdSet: p != null ? p : r,
                    onClickSeat: () => {
                    },
                    onFocusSeat: () => {
                    },
                    onUnfocusSeat: () => {
                    },
                    getTicketPriceListBySeatGroup: () => M(),
                    seatById: c,
                    seatGroupColorMap: d,
                    selectedView: u,
                    currentDomain: X.DESK
                  }
                )
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ l(
          jo,
          {
            renderingNameContext: n,
            pdfInfo: t,
            booking: i,
            seatConfig: o,
            availableSeatList: a,
            selectedView: u
          }
        )
      ]
    }
  );
  return S ? /* @__PURE__ */ l(La, { showToolbar: !1, style: { flex: 1 }, children: k }) : k;
}
const oi = Vt.create({
  page: {
    padding: 10
  }
});
function Qn() {
  const t = B(At), n = B(kt), e = B(Pe), a = Ln(), s = En(), o = Dn(), i = B(An), r = s != null ? s : K();
  return {
    renderingNameContext: Un(),
    availableSeatList: t,
    seatList: n,
    seatConfig: e,
    focusedBooking: a,
    selectedSeatIdSet: r,
    seatById: o,
    seatGroupColorMap: i
  };
}
function Kr({
  pdfInfo: t,
  relativeTransform: n,
  withPreview: e = !1
}) {
  const a = Qn();
  return /* @__PURE__ */ l(
    Jn,
    G(w({}, a), {
      pdfInfo: t,
      relativeTransform: n,
      withPreview: e,
      selectedView: O.Contingent
    })
  );
}
function ii() {
  var f, m;
  const t = ca(), [n, e] = va(), a = Ln(), { t: s } = Gt(), [o, i] = Xt(!1), { selectedView: r } = Oe(), c = fs(), d = Qn(), { order: u, cart: S } = a != null ? a : { order: null, cart: null };
  Y(u, "booking.order"), Y(S, "booking.cart");
  const g = c.eventDateStartDate ? Ae.getMoment()(c.eventDateStartDate).format(
    "DD-MM-YYYY HH[h]mm"
  ) : "", p = [
    c.ticketingTitle,
    g,
    s("pdf.filename"),
    et((m = (f = u == null ? void 0 : u["@id"]) != null ? f : S == null ? void 0 : S["@id"]) != null ? m : "")
  ].filter(Boolean).join(" - ").replace(/[^\p{L}\p{N}\s\-_.()']/gu, "").concat(".pdf");
  return Pt(() => {
    o && n.blob && (n.error && t({
      type: se.ERROR,
      title: n.error
    }), !(n.loading || !n.url) && (fa(n.url, p), i(!1)));
  }, [o, p, n, t]), /* @__PURE__ */ l($o, { children: ({ relativeTransform: L }) => /* @__PURE__ */ T(
    "a",
    {
      href: "#download-pdf",
      className: "mpd-btn",
      onClick: (b) => {
        b.preventDefault(), i(!0), e(
          /* @__PURE__ */ l(
            Jn,
            G(w({}, d), {
              relativeTransform: L,
              pdfInfo: c,
              selectedView: r
            })
          )
        );
      },
      children: [
        /* @__PURE__ */ l(St, { icon: "download" }),
        s("pdf.link.download")
      ]
    }
  ) });
}
const ta = "selected_seat", ri = [
  C.AVAILABLE,
  ta,
  C.IN_ORDER,
  C.IN_EXTERNAL_PROVIDER_ORDER,
  C.IN_RESERVATION,
  C.IN_EXTERNAL_PROVIDER_RESERVATION,
  C.IN_CART,
  C.DISMISSED,
  C.SCANNED
];
function li({
  controls: t,
  isPdfDownloadAvailable: n,
  externalActions: e
}) {
  const { t: a } = Gt(), { viewList: s, selectedView: o, onSelectView: i } = Oe(), { currentDomain: r } = Ft(), c = Ss(), d = B(ms), u = ps() || M(), S = d || c, g = Te(() => {
    switch (o) {
      case O.Contingent:
        return a("toolbar.view.contingent");
      case O.SeatGroup:
        return a("toolbar.view.seat_group");
      default:
        throw new Error(
          `Unable to get label for the selected view ${o}.`
        );
    }
  }, [o, a]);
  return /* @__PURE__ */ T("div", { className: "mpd-seating__top-toolbar", children: [
    n && /* @__PURE__ */ l("div", { className: "mpd-seating__top-toolbar__left", children: /* @__PURE__ */ l(ii, {}) }),
    /* @__PURE__ */ T("div", { className: "mpd-seating__top-toolbar__right", children: [
      /* @__PURE__ */ l("div", { className: "mr3", children: e }),
      r === X.DESK && /* @__PURE__ */ l(ua, { className: "mr3", children: /* @__PURE__ */ T(
        da,
        {
          keepOpen: !0,
          icon: "arrow-down",
          label: g(),
          labelClassName: "mr1 pl1 pr1 small bold",
          children: [
            /* @__PURE__ */ T("div", { className: "mb3", children: [
              /* @__PURE__ */ l("h3", { className: "mb2", children: a("seat.toolbar.display_view") }),
              s.includes(O.Contingent) && /* @__PURE__ */ l(
                He,
                {
                  name: "radio-view",
                  className: "mpd-seating__top-toolbar__radio mb1",
                  defaultChecked: o === O.Contingent,
                  onClick: () => i(O.Contingent),
                  children: a("toolbar.view.contingent")
                }
              ),
              s.includes(O.SeatGroup) && /* @__PURE__ */ l(
                He,
                {
                  name: "radio-view",
                  className: "mpd-seating__top-toolbar__radio",
                  defaultChecked: o === O.SeatGroup,
                  onClick: () => i(O.SeatGroup),
                  children: a("toolbar.view.seat_group")
                }
              )
            ] }),
            /* @__PURE__ */ T("div", { className: "mb3", children: [
              /* @__PURE__ */ l("h3", { className: "mb2", children: a("seat.toolbar.legend") }),
              ri.map((p) => /* @__PURE__ */ T("div", { children: [
                /* @__PURE__ */ l(
                  St,
                  {
                    icon: _o(p, !1),
                    color: ci(p),
                    width: "12"
                  }
                ),
                /* @__PURE__ */ l("span", { className: "ml2 small bold", children: a(`seat.status.${p}`) })
              ] }, p))
            ] }),
            o === O.Contingent && S && S.size > 0 && /* @__PURE__ */ T("div", { children: [
              /* @__PURE__ */ l("h3", { className: "mb2", children: a("seat.toolbar.stockContingent.color") }),
              /* @__PURE__ */ l(
                zo,
                {
                  contingentEntityList: S
                }
              )
            ] }),
            o === O.SeatGroup && u.size > 0 && /* @__PURE__ */ T("div", { children: [
              /* @__PURE__ */ l("h3", { className: "mb2", children: a("seat.toolbar.seatGroup.color") }),
              /* @__PURE__ */ l(Uo, { seatGroupList: u })
            ] })
          ]
        }
      ) }),
      t
    ] })
  ] });
}
function ci(t) {
  return t === ta ? Xs : t === C.SCANNED ? xn : lt;
}
class ea extends re {
  constructor(e) {
    super(e);
    // eslint-disable-next-line react/sort-comp
    H(this, "_svgRef");
    H(this, "_svgPanZoomReference");
    H(this, "mouseX");
    H(this, "mouseY");
    this.setSvgReference = this.setSvgReference.bind(this), this._svgRef = null, this._svgPanZoomReference = null, this.zoomIn = this.zoomIn.bind(this), this.zoomOut = this.zoomOut.bind(this), this.state = {
      focusedSeatId: null,
      participant: null
    }, this.onMouseMove = this.onMouseMove.bind(this), this.onTrackPad = this.onTrackPad.bind(this), this.onFocusSeat = this.onFocusSeat.bind(this), this.onUnfocusSeat = this.onUnfocusSeat.bind(this), this.mouseX = 0, this.mouseY = 0;
  }
  componentDidMount() {
    var e, a, s, o, i, r;
    (a = (e = this._svgRef) == null ? void 0 : e.parentElement) == null || a.addEventListener(
      "mouseup",
      this.onMouseMove,
      !0
    ), (o = (s = this._svgRef) == null ? void 0 : s.parentElement) == null || o.addEventListener(
      "mousemove",
      this.onMouseMove,
      !0
    ), (r = (i = this._svgRef) == null ? void 0 : i.parentElement) == null || r.addEventListener("wheel", this.onTrackPad);
  }
  componentWillUnmount() {
    var e, a, s, o, i, r;
    (a = (e = this._svgRef) == null ? void 0 : e.parentElement) == null || a.removeEventListener(
      "mouseup",
      this.onMouseMove,
      !0
    ), (o = (s = this._svgRef) == null ? void 0 : s.parentElement) == null || o.removeEventListener(
      "mousemove",
      this.onMouseMove,
      !0
    ), (r = (i = this._svgRef) == null ? void 0 : i.parentElement) == null || r.removeEventListener("wheel", this.onTrackPad), this._svgPanZoomReference !== null && this._svgPanZoomReference.destroy();
  }
  onMouseMove(e) {
    this.mouseX = e.clientX, this.mouseY = e.clientY;
  }
  /*
   * We use trackpad movement like any maps (google, bings...), we can't go to the left or right, only zoom.
   */
  onTrackPad(e) {
    e.preventDefault();
    let a = Math.exp(-e.deltaY / 100);
    a > 1 ? a = Math.min(a, 1.15) : a = Math.max(a, 0.85), this._svgPanZoomReference && this._svgPanZoomReference.zoomBy(a, e.offsetX, e.offsetY);
  }
  onFocusSeat(e, a) {
    this.setState({
      focusedSeatId: e,
      participant: a
    });
  }
  onUnfocusSeat(e) {
    this.setState((a) => {
      const s = a.focusedSeatId;
      return s === e ? {
        focusedSeatId: null,
        participant: null
      } : {
        focusedSeatId: s,
        participant: a.participant
      };
    });
  }
  setSvgReference(e) {
    e !== null && this._svgRef !== e && (this._svgRef = e, this._svgPanZoomReference !== null && this._svgPanZoomReference.destroy(), this._svgPanZoomReference = to(e));
  }
  zoomIn() {
    this._svgPanZoomReference && this._svgPanZoomReference.zoomIn();
  }
  zoomOut() {
    this._svgPanZoomReference && this._svgPanZoomReference.zoomOut();
  }
  countStandingAvailable(e) {
    const { getTicketPriceListBySeatGroup: a } = this.props;
    return e.filter((o) => {
      var c;
      if (E(o.seatGroup), E(o.seat), tt(o.bookingStatus), !o.seatGroup["@id"] || !a)
        return !1;
      const i = a(
        o.seatGroup["@id"],
        null
      ), r = i && i.size > 0;
      return (o == null ? void 0 : o.bookingStatus) === C.AVAILABLE && ((c = o == null ? void 0 : o.seat) == null ? void 0 : c.type) === q.STANDING && r;
    }).size;
  }
  render() {
    const {
      SeatElement: e,
      SeatConfigBlockElement: a,
      isMovingSeat: s,
      movingSeatFetchStatusInProgress: o,
      selectableSeatIdSet: i,
      onClickSeat: r,
      seatConfigBlockList: c,
      selectedSeatIdSet: d,
      seatEntityList: u,
      getTicketPriceListBySeatGroup: S,
      actionButtons: g,
      currentDomain: p,
      isPdfDownloadAvailable: f = !1,
      t: m,
      viewBox: L,
      externalActions: b,
      isSpectatorScreen: A
    } = this.props, { focusedSeatId: P, participant: k } = this.state;
    if (typeof r == "undefined" || typeof a == "undefined")
      throw new Error(
        "This should not happen as they are defined in defaultProps"
      );
    const V = p === X.MINISITE ? this.countStandingAvailable(u) : null;
    return /* @__PURE__ */ T(Mt, { children: [
      /* @__PURE__ */ l("div", { id: "modal-root" }),
      /* @__PURE__ */ l(
        "div",
        {
          className: `mpd-seating__event-blocker ${o ? "mpd-seating__event-blocker--enabled" : ""}`,
          children: /* @__PURE__ */ T("div", { className: "mpd-seating__svg-container", children: [
            V != null && V > 0 && /* @__PURE__ */ l("div", { className: "mpd-card p2 mpd-seating__alert", children: m("seating.info.mixed_placement", {
              count: V
            }) }),
            /* @__PURE__ */ l(
              "svg",
              {
                preserveAspectRatio: "xMaxYMax",
                className: "draggableSVG",
                id: "seatingSVG",
                viewBox: L ? `${L.minX} ${L.minY} ${L.width} ${L.height}` : void 0,
                children: /* @__PURE__ */ T("g", { ref: this.setSvgReference, children: [
                  /* @__PURE__ */ l("g", { className: "seatingFloors", id: "seatingFloors", children: /* @__PURE__ */ l(
                    Fo,
                    {
                      SeatElement: e,
                      isMovingSeat: s,
                      seatEntityList: u,
                      selectableSeatIdSet: i,
                      selectedSeatIdSet: d,
                      onClickSeat: r,
                      onFocusSeat: this.onFocusSeat,
                      onUnfocusSeat: this.onUnfocusSeat,
                      getTicketPriceListBySeatGroup: S
                    }
                  ) }),
                  /* @__PURE__ */ l("g", { children: c.map((nt) => /* @__PURE__ */ l(
                    a,
                    {
                      id: nt["@id"],
                      info: nt.info
                    },
                    nt["@id"]
                  )) }),
                  P && /* @__PURE__ */ l(
                    Oo,
                    {
                      seatId: P,
                      participant: k,
                      mouseX: this.mouseX,
                      mouseY: this.mouseY
                    }
                  )
                ] })
              }
            ),
            !A && /* @__PURE__ */ l(
              li,
              {
                isPdfDownloadAvailable: f,
                controls: /* @__PURE__ */ l(Do, { zoomIn: this.zoomIn, zoomOut: this.zoomOut }),
                externalActions: b
              }
            ),
            /* @__PURE__ */ l(Vo, { actionButtons: g })
          ] })
        }
      )
    ] });
  }
}
H(ea, "defaultProps", {
  onClickSeat: null,
  actionButtons: null,
  isPdfDownloadAvailable: !1,
  SeatConfigBlockElement: Mo,
  getTicketPriceListBySeatGroup: null,
  externalActions: null,
  isSpectatorScreen: !1,
  viewBox: null
});
function Zr(s) {
  var o = s, {
    seatEntityType: t,
    getSelectableSeatIdSet: n,
    seatConfigBlockList: e
  } = o, a = be(o, [
    "seatEntityType",
    "getSelectableSeatIdSet",
    "seatConfigBlockList"
  ]);
  t || console.warn("The `seatEntityType` props for `Seating` must be set.");
  const { t: i } = Gt(), { currentDomain: r } = Ft(), c = bn().getState(), d = B(kt) || M();
  let u;
  const S = gs(), g = B(
    (b) => b.seating.get("availableSeatModelList")
  );
  t === "AvailableSeat" && As(c) && S ? u = S : t === "AvailableSeatModel" && Ts(c) && g ? u = g : t === "Seat" && _s(c) ? u = d : u = M();
  const p = B(
    (b) => b.seating.getIn(["movingSeat-fetch-status", "status"]) === "IN_PROGRESS"
  ), f = B(
    (b) => b.seating.get("selectedSeatIdSet")
  ), m = Ms(
    c,
    n
  ), L = Kn(d, e);
  return /* @__PURE__ */ l("div", { className: "mpd-seating__seating", id: "mpd-seating__seating", children: /* @__PURE__ */ l(
    ea,
    G(w({}, a), {
      viewBox: L,
      seatConfigBlockList: e,
      movingSeatFetchStatusInProgress: p,
      seatEntityList: u,
      selectedSeatIdSet: f,
      selectableSeatIdSet: m,
      currentDomain: r,
      t: i
    })
  ) });
}
function jr({ isDrawing: t, onChange: n }) {
  const e = lo(), a = typeof n != "undefined" ? n : e.setIsDrawing, s = typeof t != "undefined" ? t : e.isDrawing;
  return /* @__PURE__ */ T("div", { className: "mpd-btn-group", children: [
    /* @__PURE__ */ l(
      "button",
      {
        type: "button",
        className: Wt("mpd-btn mpd-btn--icon-only", {
          selected: !s
        }),
        onClick: () => a(!1),
        children: /* @__PURE__ */ l(St, { icon: "selection", width: "20" })
      }
    ),
    /* @__PURE__ */ l(
      "button",
      {
        type: "button",
        className: Wt("mpd-btn mpd-btn--icon-only", {
          selected: s
        }),
        onClick: () => a(!0),
        children: /* @__PURE__ */ l(St, { icon: "pen", width: "20" })
      }
    )
  ] });
}
export {
  lt as $,
  ur as A,
  zr as B,
  cr as C,
  Sr as D,
  Zr as E,
  jr as F,
  bn as G,
  it as H,
  Pe as I,
  As as J,
  $i as K,
  Oe as L,
  mo as M,
  qs as N,
  or as O,
  Mi as P,
  Gr as Q,
  sr as R,
  Br as S,
  R as T,
  Rr as U,
  ar as V,
  O as W,
  Ae as X,
  ne as Y,
  _e as Z,
  Nt as _,
  Di as a,
  Ji as a$,
  qt as a0,
  Tr as a1,
  Cr as a2,
  Hr as a3,
  Me as a4,
  oo as a5,
  Bi as a6,
  ir as a7,
  Mn as a8,
  Fi as a9,
  mr as aA,
  Hi as aB,
  Ln as aC,
  Wr as aD,
  gr as aE,
  Xr as aF,
  Re as aG,
  Dr as aH,
  er as aI,
  _s as aJ,
  ce as aK,
  rr as aL,
  Bn as aM,
  xi as aN,
  kr as aO,
  wr as aP,
  Qi as aQ,
  Vi as aR,
  Yi as aS,
  An as aT,
  cs as aU,
  Uo as aV,
  lr as aW,
  Hs as aX,
  Nr as aY,
  Es as aZ,
  tr as a_,
  hr as aa,
  yr as ab,
  qi as ac,
  ys as ad,
  Ar as ae,
  Wi as af,
  Ki as ag,
  Zi as ah,
  ms as ai,
  vr as aj,
  Xi as ak,
  nr as al,
  ji as am,
  Fr as an,
  Ts as ao,
  fr as ap,
  Er as aq,
  Or as ar,
  qe as as,
  Ua as at,
  yi as au,
  Oa as av,
  Ga as aw,
  Ra as ax,
  Yr as ay,
  Be as az,
  zi as b,
  Pr as b0,
  Ir as b1,
  es as b2,
  Qa as b3,
  Ja as b4,
  qa as b5,
  ja as b6,
  $a as b7,
  ki as b8,
  wi as b9,
  Io as bA,
  en as bB,
  fe as bC,
  $r as bD,
  kt as bE,
  Kn as bF,
  fs as bG,
  Un as bH,
  Kr as bI,
  xr as bJ,
  Vr as bK,
  Ws as bL,
  mt as bM,
  On as bN,
  Mo as bO,
  Tt as bP,
  eo as bQ,
  no as bR,
  Qs as bS,
  za as ba,
  Va as bb,
  Ni as bc,
  Pi as bd,
  Ii as be,
  Ba as bf,
  Fa as bg,
  xa as bh,
  Xa as bi,
  Wa as bj,
  Ha as bk,
  mn as bl,
  Ri as bm,
  Ma as bn,
  Da as bo,
  wa as bp,
  le as bq,
  Za as br,
  Ka as bs,
  Sn as bt,
  ts as bu,
  ho as bv,
  rt as bw,
  Mr as bx,
  W as by,
  $o as bz,
  Gi as c,
  Oi as d,
  Gt as e,
  ps as f,
  Lt as g,
  Lr as h,
  lo as i,
  En as j,
  br as k,
  B as l,
  gs as m,
  Ss as n,
  Rn as o,
  Ya as p,
  Fn as q,
  pr as r,
  vt as s,
  dr as t,
  de as u,
  Zs as v,
  _o as w,
  Ui as x,
  _r as y,
  Os as z
};
//# sourceMappingURL=App-ChpItgs-.js.map
